import React, { useState, Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux'
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { host } from '../../../../configuraciones'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import {
    /*actualizarFC_36PaginaActivaEnvasado,
    agregarFC_36AnexoUnidadEnvasado,
    editarFC_36AnexoUnidadEnvasado,
    guardarCambiosFC_36AnexoUnidadEnvasado,
    registrarSolicitudFC_36Accion,
    eliminarFC_36AnexoEnvasadoMap, agregarFC_36AnexoUnidadEnvasadoMap,
    agregarFC_36AnexoUnidadEnvasadoMapRevision, eliminarFC_36AnexoEnvasadoMapRevision*/
} from '../../../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks'
import ToolBarPaginas from '../../../App/ToolBarPaginas'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster)


import estilos from '../AtencionAClientesFC_36Component.module.css';


import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


function FC_36AnexoEnvasadoComponent(props) {
    const dispatch = useDispatch()

    const mayor = '>'
    const menor = '<'
    var fechaHoy = moment().format('YYYY-MM-DD');

    let idEditable = 0
    if (props.history.location.state) {
        idEditable = props.history.location.state.idEdit
    }

    const anexoEnvasadoEditable = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadEnvasado).filter(anexo => anexo.data.id === idEditable)
    const anexoEnvasadoFormato = useSelector(store => store.AtencionSolicitud.formato?.fc_36_anexounidaddeenvasado)?.filter(anexo => anexo.id === idEditable)
    const anexoUnidadEnvasadoMap = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadEnvasadoMap)

    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const paginaActiva = useSelector(store => store.FC_36SolicitudAtencionACliente.paginaActivaEnvasado)
    const anexoUnidadEnvasadoMapRevision = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadEnvasadoMapRevision)
    
    /*Datos FC_36 Anexo Unidad de Envasado*/
    const [nocliente, setnocliente] = useState(7)
    const [nombrerazonsocial, setnombrerazonsocialenvasado] = useStateIfMounted('')
    const [altainstalaciones, setaltainstalacionesenvasado] = useStateIfMounted(false)
    const [bajainstalaciones, setbajainstalacionesenvasado] = useStateIfMounted(false)
    const [fechasolicitud, setfechasolicitudenvasado] = useStateIfMounted(fechaHoy)
    const [fechapropuesta, setfechapropuestaenvasado] = useStateIfMounted(fechaHoy)
    const [instalacionnumero, setinstalacionnumeroenvasado] = useStateIfMounted(0)
    const [tipoinstalacion, settipoinstalacionenvasado] = useStateIfMounted('')
    const [alias, setaliasenvasado] = useStateIfMounted('')
    const [calle, setcalleenvasado] = useStateIfMounted('')
    const [numeroexterior, setnumeroexteriorenvasado] = useStateIfMounted(0)
    const [numerointerior, setnumerointeriorenvasado] = useStateIfMounted(0)
    const [colonia, setcoloniaenvasado] = useStateIfMounted('')
    const [localidad, setlocalidadenvasado] = useStateIfMounted('')
    const [municipio, setmunicipioenvasado] = useStateIfMounted('')
    const [estado, setestadoenvasado] = useStateIfMounted('')
    const [codigopostal, setcodigopostalenvasado] = useStateIfMounted('')
    const [referenciascercanas, setreferenciascercanasenvasado] = useStateIfMounted('')
    const [telefono, settelefonoenvasado] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronicoenvasado] = useStateIfMounted('')
    const [nombreresponsable, setnombreresponsableenvasado] = useStateIfMounted('')
    const [anforasplastico, setanforasplasticoenvasado] = useStateIfMounted(false)
    const [cantidadanforasplastico, setcantidadanforasplasticoenvasado] = useStateIfMounted(0)
    const [capacidadanforasplastico, setcapacidadanforasplasticoenvasado] = useStateIfMounted(0)
    const [tambosplasticos, settambosplasticosenvasado] = useStateIfMounted(false)
    const [cantidadtambosplasticos, setcantidadtambosplasticosenvasado] = useStateIfMounted(0)
    const [capacidadtambosplasticos, setcapacidadtambosplasticosenvasado] = useStateIfMounted(0)
    const [contenedoresplastico1000, setcontenedoresplastico1000envasado] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico100, setcantidadcontenedoresplastico100envasado] = useStateIfMounted(0)
    const [capacidadcontenedoresplastico10, setcapacidadcontenedoresplastico10envasado] = useStateIfMounted(0)
    const [contenedoresplastico5000, setcontenedoresplastico5000envasado] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico500, setcantidadcontenedoresplastico500envasado] = useStateIfMounted(0)
    const [capacidadcontenedoresplastico50, setcapacidadcontenedoresplastico50envasado] = useStateIfMounted(0)
    const [recipientesaceroinoxidable, setrecipientesaceroinoxidableenvasado] = useStateIfMounted(false)
    const [cantidadrecipientesaceroinoxida, setcantidadrecipientesaceroinoxidaenvasado] = useStateIfMounted(0)
    const [capacidadrecipientesaceroinoxid, setcapacidadrecipientesaceroinoxidenvasado] = useStateIfMounted(0)
    const [otroalmacengraneles, setotroalmacengranelesenvasado] = useStateIfMounted(false)
    const [opcionotroalmacengraneles, setopcionotroalmacengranelesenvasado] = useStateIfMounted('')
    const [cantidadotroalmacengraneles, setcantidadotroalmacengranelesenvasado] = useStateIfMounted(0)
    const [capacidadotroalmacengraneles, setcapacidadotroalmacengranelesenvasado] = useStateIfMounted(0)
    const [filtrocartucho, setfiltrocartucho] = useStateIfMounted(false)
    const [cantidadfiltrocartucho, setcantidadfiltrocartucho] = useStateIfMounted(0)
    const [caracteristicasfiltrocartucho, setcaracteristicasfiltrocartucho] = useStateIfMounted('')
    const [filtroprensa, setfiltroprensa] = useStateIfMounted(false)
    const [cantidadfiltroprensa, setcantidadfiltroprensa] = useStateIfMounted(0)
    const [caracteristicasfiltroprensa, setcaracteristicasfiltroprensa] = useStateIfMounted('')
    const [otrofiltracionmezcal, setotrofiltracionmezcal] = useStateIfMounted(false)
    const [opcionotrofiltracionmezcal, setopcionotrofiltracionmezcal] = useStateIfMounted('')
    const [cantidadotrofiltracionmezcal, setcantidadotrofiltracionmezcal] = useStateIfMounted(0)
    const [caracteristicasotrofiltracionme, setcaracteristicasotrofiltracionme] = useStateIfMounted('')
    const [llenadoramanual, setllenadoramanual] = useStateIfMounted(false)
    const [cantidadllenadoramanual, setcantidadllenadoramanual] = useStateIfMounted(0)
    const [capacidadllenadoramanual, setcapacidadllenadoramanual] = useStateIfMounted(0)
    const [llenadoraautomatica, setllenadoraautomatica] = useStateIfMounted(false)
    const [cantidadllenadoraautomatica, setcantidadllenadoraautomatica] = useStateIfMounted(0)
    const [capacidadllenadoraautomatica, setcapacidadllenadoraautomatica] = useStateIfMounted(0)
    const [otrollenadobotellas, setotrollenadobotellas] = useStateIfMounted(false)
    const [opcionotrollenadobotellas, setopcionotrollenadobotellas] = useStateIfMounted('')
    const [cantidadotrollenadobotellas, setcantidadotrollenadobotellas] = useStateIfMounted(0)
    const [capacidadotrollenadobotellas, setcapacidadotrollenadobotellas] = useStateIfMounted(0)
    const [taponadomanual, settaponadomanual] = useStateIfMounted(false)
    const [cantidadtaponadomanual, setcantidadtaponadomanual] = useStateIfMounted(0)
    const [capacidadtaponadomanual, setcapacidadtaponadomanual] = useStateIfMounted(0)
    const [taponadoautomatico, settaponadoautomatico] = useStateIfMounted(false)
    const [cantidadtaponadoautomatico, setcantidadtaponadoautomatico] = useStateIfMounted(0)
    const [capacidadtaponadoautomatico, setcapacidadtaponadoautomatico] = useStateIfMounted(0)
    const [otrotaponadobotellas, setotrotaponadobotellas] = useStateIfMounted(false)
    const [opcionotrotaponadobotellas, setopcionotrotaponadobotellas] = useStateIfMounted('')
    const [cantidadotrotaponadobotellas, setcantidadotrotaponadobotellas] = useStateIfMounted(0)
    const [capacidadotrotaponadobotellas, setcapacidadotrotaponadobotellas] = useStateIfMounted(0)
    const [selladomanual, setselladomanual] = useStateIfMounted(false)
    const [cantidadselladomanual, setcantidadselladomanual] = useStateIfMounted(0)
    const [capacidadselladomanual, setcapacidadselladomanual] = useStateIfMounted(0)
    const [selladoautomatico, setselladoautomatico] = useStateIfMounted(false)
    const [cantidadselladoautomatico, setcantidadselladoautomatico] = useStateIfMounted(0)
    const [capacidadselladoautomatico, setcapacidadselladoautomatico] = useStateIfMounted(0)
    const [otroselladobotellas, setotroselladobotellas] = useStateIfMounted(false)
    const [opcionotroselladobotellas, setopcionotroselladobotellas] = useStateIfMounted('')
    const [cantidadotroselladobotellas, setcantidadotroselladobotellas] = useStateIfMounted(0)
    const [capacidadotroselladobotellas, setcapacidadotroselladobotellas] = useStateIfMounted(0)
    const [etiquetadomanual, setetiquetadomanual] = useStateIfMounted(false)
    const [cantidadetiquetadomanual, setcantidadetiquetadomanual] = useStateIfMounted(0)
    const [capacidadetiquetadomanual, setcapacidadetiquetadomanual] = useStateIfMounted(0)
    const [etiquetadoautomatico, setetiquetadoautomatico] = useStateIfMounted(false)
    const [cantidadetiquetadoautomatico, setcantidadetiquetadoautomatico] = useStateIfMounted(0)
    const [capacidadetiquetadoautomatico, setcapacidadetiquetadoautomatico] = useStateIfMounted(0)
    const [otroetiquetadobotellas, setotroetiquetadobotellas] = useStateIfMounted(false)
    const [opcionotroetiquetadobotellas, setopcionotroetiquetadobotellas] = useStateIfMounted('')
    const [cantidadotroetiquetadobotellas, setcantidadotroetiquetadobotellas] = useStateIfMounted(0)
    const [capacidadotroetiquetadobotellas, setcapacidadotroetiquetadobotellas] = useStateIfMounted(0)

    const setAccionInstalacion = (target) => {
        if (target.id === 'alta') {
            if (target.checked) {
                setaltainstalacionesenvasado(true)
                setbajainstalacionesenvasado(false)
            }

        } else if (target.id === 'baja') {
            if (target.checked) {
                setbajainstalacionesenvasado(true)
                setaltainstalacionesenvasado(false)
            }
        }
    }
    //variables para los checks de observaciones 
    const [nombrerazonsocialcheck, setnombrerazonsocialcheck] = useStateIfMounted(false)
    const [altainstalacionescheck, setaltainstalacionescheck] = useStateIfMounted(false)
    const [bajainstalacionescheck, setbajainstalacionescheck] = useStateIfMounted(false)
    const [fechasolicitudcheck, setfechasolicitudcheck] = useStateIfMounted(false)
    const [fechapropuestacheck, setfechapropuestacheck] = useStateIfMounted(false)
    const [instalacionnumerocheck, setinstalacionnumerocheck] = useStateIfMounted(false)
    const [tipoinstalacioncheck, settipoinstalacioncheck] = useStateIfMounted(false)
    const [aliascheck, setaliascheck] = useStateIfMounted(false)
    const [callecheck, setcallecheck] = useStateIfMounted(false)
    const [numeroexteriorcheck, setnumeroexteriorcheck] = useStateIfMounted(false)
    const [numerointeriorcheck, setnumerointeriorcheck] = useStateIfMounted(false)
    const [coloniacheck, setcoloniacheck] = useStateIfMounted(false)
    const [localidadcheck, setlocalidadcheck] = useStateIfMounted(false)
    const [municipiocheck, setmunicipiocheck] = useStateIfMounted(false)
    const [estadocheck, setestadocheck] = useStateIfMounted(false)
    const [codigopostalcheck, setcodigopostalcheck] = useStateIfMounted(false)
    const [referenciascercanascheck, setreferenciascercanascheck] = useStateIfMounted(false)
    const [telefonocheck, settelefonocheck] = useStateIfMounted(false)
    const [correoelectronicocheck, setcorreoelectronicocheck] = useStateIfMounted(false)
    const [nombreresponsablecheck, setnombreresponsablecheck] = useStateIfMounted(false)
    const [anforasplasticocheck, setanforasplasticocheck] = useStateIfMounted(false)
    const [cantidadanforasplasticocheck, setcantidadanforasplasticocheck] = useStateIfMounted(false)
    const [capacidadanforasplasticocheck, setcapacidadanforasplasticocheck] = useStateIfMounted(false)
    const [tambosplasticoscheck, settambosplasticoscheck] = useStateIfMounted(false)
    const [cantidadtambosplasticoscheck, setcantidadtambosplasticoscheck] = useStateIfMounted(false)
    const [capacidadtambosplasticoscheck, setcapacidadtambosplasticoscheck] = useStateIfMounted(false)
    const [contenedoresplastico1000check, setcontenedoresplastico1000check] = useStateIfMounted(false)
    const [cantidadcontplastico100check, setcantidadcontplastico100check] = useStateIfMounted(false)
    const [capacidadcontplastico10check, setcapacidadcontplastico10check] = useStateIfMounted(false)
    const [contenedoresplastico10000check, setcontenedoresplastico10000check] = useStateIfMounted(false)
    const [cantidadcontplastico1000check, setcantidadcontplastico1000check] = useStateIfMounted(false)
    const [capacidadcontplastico100check, setcapacidadcontplastico100check] = useStateIfMounted(false)
    const [recipientesaceroinoxidablecheck, setrecipientesaceroinoxidablecheck] = useStateIfMounted(false)
    const [cantidadrecaceroinoxidacheck, setcantidadrecaceroinoxidacheck] = useStateIfMounted(false)
    const [capacidadrecaceroinoxidcheck, setcapacidadrecaceroinoxidcheck] = useStateIfMounted(false)
    const [otroalmacengranelescheck, setotroalmacengranelescheck] = useStateIfMounted(false)
    const [opcionotroalmacengranelescheck, setopcionotroalmacengranelescheck] = useStateIfMounted(false)
    const [cantidadotroalmacengranelescheck, setcantidadotroalmacengranelescheck] = useStateIfMounted(false)
    const [capacidadotroalmacengranelescheck, setcapacidadotroalmacengranelescheck] = useStateIfMounted(false)
    const [filtrocartuchocheck, setfiltrocartuchocheck] = useStateIfMounted(false)
    const [cantidadfiltrocartuchocheck, setcantidadfiltrocartuchocheck] = useStateIfMounted(false)
    const [caracteristicasfiltrocartuchocheck, setcaracteristicasfiltrocartuchocheck] = useStateIfMounted(false)
    const [filtroprensacheck, setfiltroprensacheck] = useStateIfMounted(false)
    const [cantidadfiltroprensacheck, setcantidadfiltroprensacheck] = useStateIfMounted(false)
    const [caracteristicasfiltroprensacheck, setcaracteristicasfiltroprensacheck] = useStateIfMounted(false)
    const [otrofiltracionmezcalcheck, setotrofiltracionmezcalcheck] = useStateIfMounted(false)
    const [opcionotrofiltracionmezcalcheck, setopcionotrofiltracionmezcalcheck] = useStateIfMounted(false)
    const [cantidadotrofiltracionmezcalcheck, setcantidadotrofiltracionmezcalcheck] = useStateIfMounted(false)
    const [caracteristicasotrofiltracionmecheck, setcaracteristicasotrofiltracionmecheck] = useStateIfMounted(false)
    const [llenadoramanualcheck, setllenadoramanualcheck] = useStateIfMounted(false)
    const [cantidadllenadoramanualcheck, setcantidadllenadoramanualcheck] = useStateIfMounted(false)
    const [capacidadllenadoramanualcheck, setcapacidadllenadoramanualcheck] = useStateIfMounted(false)
    const [llenadoraautomaticacheck, setllenadoraautomaticacheck] = useStateIfMounted(false)
    const [cantidadllenadoraautomaticacheck, setcantidadllenadoraautomaticacheck] = useStateIfMounted(false)
    const [capacidadllenadoraautomaticacheck, setcapacidadllenadoraautomaticacheck] = useStateIfMounted(false)
    const [otrollenadobotellascheck, setotrollenadobotellascheck] = useStateIfMounted(false)
    const [opcionotrollenadobotellascheck, setopcionotrollenadobotellascheck] = useStateIfMounted(false)
    const [cantidadotrollenadobotellascheck, setcantidadotrollenadobotellascheck] = useStateIfMounted(false)
    const [capacidadotrollenadobotellascheck, setcapacidadotrollenadobotellascheck] = useStateIfMounted(false)
    const [taponadomanualcheck, settaponadomanualcheck] = useStateIfMounted(false)
    const [cantidadtaponadomanualcheck, setcantidadtaponadomanualcheck] = useStateIfMounted(false)
    const [capacidadtaponadomanualcheck, setcapacidadtaponadomanualcheck] = useStateIfMounted(false)
    const [taponadoautomaticocheck, settaponadoautomaticocheck] = useStateIfMounted(false)
    const [cantidadtaponadoautomaticocheck, setcantidadtaponadoautomaticocheck] = useStateIfMounted(false)
    const [capacidadtaponadoautomaticocheck, setcapacidadtaponadoautomaticocheck] = useStateIfMounted(false)
    const [otrotaponadobotellascheck, setotrotaponadobotellascheck] = useStateIfMounted(false)
    const [opcionotrotaponadobotellascheck, setopcionotrotaponadobotellascheck] = useStateIfMounted(false)
    const [cantidadotrotaponadobotellascheck, setcantidadotrotaponadobotellascheck] = useStateIfMounted(false)
    const [capacidadotrotaponadobotellascheck, setcapacidadotrotaponadobotellascheck] = useStateIfMounted(false)
    const [selladomanualcheck, setselladomanualcheck] = useStateIfMounted(false)
    const [cantidadselladomanualcheck, setcantidadselladomanualcheck] = useStateIfMounted(false)
    const [capacidadselladomanualcheck, setcapacidadselladomanualcheck] = useStateIfMounted(false)
    const [selladoautomaticocheck, setselladoautomaticocheck] = useStateIfMounted(false)
    const [cantidadselladoautomaticocheck, setcantidadselladoautomaticocheck] = useStateIfMounted(false)
    const [capacidadselladoautomaticocheck, setcapacidadselladoautomaticocheck] = useStateIfMounted(false)
    const [otroselladobotellascheck, setotroselladobotellascheck] = useStateIfMounted(false)
    const [opcionotroselladobotellascheck, setopcionotroselladobotellascheck] = useStateIfMounted(false)
    const [cantidadotroselladobotellascheck, setcantidadotroselladobotellascheck] = useStateIfMounted(false)
    const [capacidadotroselladobotellascheck, setcapacidadotroselladobotellascheck] = useStateIfMounted(false)
    const [etiquetadomanualcheck, setetiquetadomanualcheck] = useStateIfMounted(false)
    const [cantidadetiquetadomanualcheck, setcantidadetiquetadomanualcheck] = useStateIfMounted(false)
    const [capacidadetiquetadomanualcheck, setcapacidadetiquetadomanualcheck] = useStateIfMounted(false)
    const [etiquetadoautomaticocheck, setetiquetadoautomaticocheck] = useStateIfMounted(false)
    const [cantidadetiquetadoautomaticocheck, setcantidadetiquetadoautomaticocheck] = useStateIfMounted(false)
    const [capacidadetiquetadoautomaticocheck, setcapacidadetiquetadoautomaticocheck] = useStateIfMounted(false)
    const [otroetiquetadobotellascheck, setotroetiquetadobotellascheck] = useStateIfMounted(false)
    const [opcionotroetiquetadobotellascheck, setopcionotroetiquetadobotellascheck] = useStateIfMounted(false)
    const [cantidadotroetiquetadobotellascheck, setcantidadotroetiquetadobotellascheck] = useStateIfMounted(false)
    const [capacidadotroetiquetadobotellascheck, setcapacidadotroetiquetadobotellascheck] = useStateIfMounted(false)

    const [observaciones, setObservaciones] = useStateIfMounted({
        nombrerazonsocial: '', altainstalaciones: '', bajainstalaciones: '',
        fechasolicitud: '', fechapropuesta: '', instalacionnumero: '', tipoinstalacion: '',
        alias: '', calle: '', numeroexterior: '', numerointerior: '', colonia: '', localidad: '',
        municipio: '', estado: '', codigopostal: '', referenciascercanas: '', telefono: '',
        correoelectronico: '', nombreresponsable: '', anforasplastico: '',
        cantidadanforasplastico: '', capacidadanforasplastico: '', tambosplasticos: '',
        cantidadtambosplasticos: '', capacidadtambosplasticos: '', contenedoresplastico1000: '',
        cantidadcontplastico100: '', capacidadcontplastico10: '', contenedoresplastico10000: '',
        cantidadcontplastico1000: '', capacidadcontplastico100: '', recipientesaceroinoxidable: '',
        cantidadrecaceroinoxida: '', capacidadrecaceroinoxid: '', otroalmacengraneles: '',
        opcionotroalmacengraneles: '', cantidadotroalmacengraneles: '',
        capacidadotroalmacengraneles: '', filtrocartucho: '', cantidadfiltrocartucho: '',
        caracteristicasfiltrocartucho: '', filtroprensa: '', cantidadfiltroprensa: '',
        caracteristicasfiltroprensa: '', otrofiltracionmezcal: '', opcionotrofiltracionmezcal: '',
        cantidadotrofiltracionmezcal: '', caracteristicasotrofiltracionme: '', llenadoramanual: '',
        cantidadllenadoramanual: '', capacidadllenadoramanual: '', llenadoraautomatica: '',
        cantidadllenadoraautomatica: '', capacidadllenadoraautomatica: '',
        otrollenadobotellas: '', opcionotrollenadobotellas: '', cantidadotrollenadobotellas: '',
        capacidadotrollenadobotellas: '', taponadomanual: '', cantidadtaponadomanual: '',
        capacidadtaponadomanual: '', taponadoautomatico: '', cantidadtaponadoautomatico: '',
        capacidadtaponadoautomatico: '', otrotaponadobotellas: '', opcionotrotaponadobotellas: '',
        cantidadotrotaponadobotellas: '', capacidadotrotaponadobotellas: '', selladomanual: '',
        cantidadselladomanual: '', capacidadselladomanual: '', selladoautomatico: '',
        cantidadselladoautomatico: '', capacidadselladoautomatico: '', otroselladobotellas: '',
        opcionotroselladobotellas: '', cantidadotroselladobotellas: '',
        capacidadotroselladobotellas: '', etiquetadomanual: '', cantidadetiquetadomanual: '',
        capacidadetiquetadomanual: '', etiquetadoautomatico: '', cantidadetiquetadoautomatico: '',
        capacidadetiquetadoautomatico: '', otroetiquetadobotellas: '',
        opcionotroetiquetadobotellas: '', cantidadotroetiquetadobotellas: '',
        capacidadotroetiquetadobotellas: ''
    });
    const checknombrerazonsocialcheck = () => {
        if (!nombrerazonsocialcheck) {
            setnombrerazonsocialcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('nombrerazonsocial')
        } else {
            setnombrerazonsocialcheck(false)
            observaciones['nombrerazonsocial'] = ''
        }
    }
    const checkaltainstalacionescheck = () => {
        if (!altainstalacionescheck) {
            setaltainstalacionescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('altainstalaciones')
        } else {
            setaltainstalacionescheck(false)
            observaciones['altainstalaciones'] = ''
        }
    }
    const checkbajainstalacionescheck = () => {
        if (!bajainstalacionescheck) {
            setbajainstalacionescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('bajainstalaciones')
        } else {
            setbajainstalacionescheck(false)
            observaciones['bajainstalaciones'] = ''
        }
    }
    const checkfechasolicitudcheck = () => {
        if (!fechasolicitudcheck) {
            setfechasolicitudcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('fechasolicitud')
        } else {
            setfechasolicitudcheck(false)
            observaciones['fechasolicitud'] = ''
        }
    }
    const checkfechapropuestacheck = () => {
        if (!fechapropuestacheck) {
            setfechapropuestacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('fechapropuesta')
        } else {
            setfechapropuestacheck(false)
            observaciones['fechapropuesta'] = ''
        }
    }
    const checkinstalacionnumerocheck = () => {
        if (!instalacionnumerocheck) {
            setinstalacionnumerocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('instalacionnumero')
        } else {
            setinstalacionnumerocheck(false)
            observaciones['instalacionnumero'] = ''
        }
    }
    const checktipoinstalacioncheck = () => {
        if (!tipoinstalacioncheck) {
            settipoinstalacioncheck(true)
            handleOpenModalObservaciones()
            mostrarModal('tipoinstalacion')
        } else {
            settipoinstalacioncheck(false)
            observaciones['tipoinstalacion'] = ''
        }
    }
    const checkaliascheck = () => {
        if (!aliascheck) {
            setaliascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('alias')
        } else {
            setaliascheck(false)
            observaciones['alias'] = ''
        }
    }
    const checkcallecheck = () => {
        if (!callecheck) {
            setcallecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('calle')
        } else {
            setcallecheck(false)
            observaciones['calle'] = ''
        }
    }
    const checknumeroexteriorcheck = () => {
        if (!numeroexteriorcheck) {
            setnumeroexteriorcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('numeroexterior')
        } else {
            setnumeroexteriorcheck(false)
            observaciones['numeroexterior'] = ''
        }
    }
    const checknumerointeriorcheck = () => {
        if (!numerointeriorcheck) {
            setnumerointeriorcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('numerointerior')
        } else {
            setnumerointeriorcheck(false)
            observaciones['numerointerior'] = ''
        }
    }
    const checkcoloniacheck = () => {
        if (!coloniacheck) {
            setcoloniacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('colonia')
        } else {
            setcoloniacheck(false)
            observaciones['colonia'] = ''
        }
    }
    const checklocalidadcheck = () => {
        if (!localidadcheck) {
            setlocalidadcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('localidad')
        } else {
            setlocalidadcheck(false)
            observaciones['localidad'] = ''
        }
    }
    const checkmunicipiocheck = () => {
        if (!municipiocheck) {
            setmunicipiocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('municipio')
        } else {
            setmunicipiocheck(false)
            observaciones['municipio'] = ''
        }
    }
    const checkestadocheck = () => {
        if (!estadocheck) {
            setestadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('estado')
        } else {
            setestadocheck(false)
            observaciones['estado'] = ''
        }
    }
    const checkcodigopostalcheck = () => {
        if (!codigopostalcheck) {
            setcodigopostalcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('codigopostal')
        } else {
            setcodigopostalcheck(false)
            observaciones['codigopostal'] = ''
        }
    }
    const checkreferenciascercanascheck = () => {
        if (!referenciascercanascheck) {
            setreferenciascercanascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('referenciascercanas')
        } else {
            setreferenciascercanascheck(false)
            observaciones['referenciascercanas'] = ''
        }
    }
    const checktelefonocheck = () => {
        if (!telefonocheck) {
            settelefonocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('telefono')
        } else {
            settelefonocheck(false)
            observaciones['telefono'] = ''
        }
    }
    const checkcorreoelectronicocheck = () => {
        if (!correoelectronicocheck) {
            setcorreoelectronicocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('correoelectronico')
        } else {
            setcorreoelectronicocheck(false)
            observaciones['correoelectronico'] = ''
        }
    }
    const checknombreresponsablecheck = () => {
        if (!nombreresponsablecheck) {
            setnombreresponsablecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('nombreresponsable')
        } else {
            setnombreresponsablecheck(false)
            observaciones['nombreresponsable'] = ''
        }
    }
    const checkanforasplasticocheck = () => {
        if (!anforasplasticocheck) {
            setanforasplasticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('anforasplastico')
        } else {
            setanforasplasticocheck(false)
            observaciones['anforasplastico'] = ''
        }
    }
    const checkcantidadanforasplasticocheck = () => {
        if (!cantidadanforasplasticocheck) {
            setcantidadanforasplasticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadanforasplastico')
        } else {
            setcantidadanforasplasticocheck(false)
            observaciones['cantidadanforasplastico'] = ''
        }
    }
    const checkcapacidadanforasplasticocheck = () => {
        if (!capacidadanforasplasticocheck) {
            setcapacidadanforasplasticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadanforasplastico')
        } else {
            setcapacidadanforasplasticocheck(false)
            observaciones['capacidadanforasplastico'] = ''
        }
    }
    const checktambosplasticoscheck = () => {
        if (!tambosplasticoscheck) {
            settambosplasticoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('tambosplasticos')
        } else {
            settambosplasticoscheck(false)
            observaciones['tambosplasticos'] = ''
        }
    }
    const checkcantidadtambosplasticoscheck = () => {
        if (!cantidadtambosplasticoscheck) {
            setcantidadtambosplasticoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadtambosplasticos')
        } else {
            setcantidadtambosplasticoscheck(false)
            observaciones['cantidadtambosplasticos'] = ''
        }
    }
    const checkcapacidadtambosplasticoscheck = () => {
        if (!capacidadtambosplasticoscheck) {
            setcapacidadtambosplasticoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadtambosplasticos')
        } else {
            setcapacidadtambosplasticoscheck(false)
            observaciones['capacidadtambosplasticos'] = ''
        }
    }
    const checkcontenedoresplastico1000check = () => {
        if (!contenedoresplastico1000check) {
            setcontenedoresplastico1000check(true)
            handleOpenModalObservaciones()
            mostrarModal('contenedoresplastico1000')
        } else {
            setcontenedoresplastico1000check(false)
            observaciones['contenedoresplastico1000'] = ''
        }
    }
    const checkcantidadcontplastico100check = () => {
        if (!cantidadcontplastico100check) {
            setcantidadcontplastico100check(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadcontplastico100')
        } else {
            setcantidadcontplastico100check(false)
            observaciones['cantidadcontplastico100'] = ''
        }
    }
    const checkcapacidadcontplastico10check = () => {
        if (!capacidadcontplastico10check) {
            setcapacidadcontplastico10check(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadcontplastico10')
        } else {
            setcapacidadcontplastico10check(false)
            observaciones['capacidadcontplastico10'] = ''
        }
    }
    const checkcontenedoresplastico10000check = () => {
        if (!contenedoresplastico10000check) {
            setcontenedoresplastico10000check(true)
            handleOpenModalObservaciones()
            mostrarModal('contenedoresplastico10000')
        } else {
            setcontenedoresplastico10000check(false)
            observaciones['contenedoresplastico10000'] = ''
        }
    }
    const checkcantidadcontplastico1000check = () => {
        if (!cantidadcontplastico1000check) {
            setcantidadcontplastico1000check(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadcontplastico1000')
        } else {
            setcantidadcontplastico1000check(false)
            observaciones['cantidadcontplastico1000'] = ''
        }
    }
    const checkcapacidadcontplastico100check = () => {
        if (!capacidadcontplastico100check) {
            setcapacidadcontplastico100check(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadcontplastico100')
        } else {
            setcapacidadcontplastico100check(false)
            observaciones['capacidadcontplastico100'] = ''
        }
    }
    const checkrecipientesaceroinoxidablecheck = () => {
        if (!recipientesaceroinoxidablecheck) {
            setrecipientesaceroinoxidablecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('recipientesaceroinoxidable')
        } else {
            setrecipientesaceroinoxidablecheck(false)
            observaciones['recipientesaceroinoxidable'] = ''
        }
    }
    const checkcantidadrecaceroinoxidacheck = () => {
        if (!cantidadrecaceroinoxidacheck) {
            setcantidadrecaceroinoxidacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadrecaceroinoxida')
        } else {
            setcantidadrecaceroinoxidacheck(false)
            observaciones['cantidadrecaceroinoxida'] = ''
        }
    }
    const checkcapacidadrecaceroinoxidcheck = () => {
        if (!capacidadrecaceroinoxidcheck) {
            setcapacidadrecaceroinoxidcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadrecaceroinoxid')
        } else {
            setcapacidadrecaceroinoxidcheck(false)
            observaciones['capacidadrecaceroinoxid'] = ''
        }
    }
    const checkotroalmacengranelescheck = () => {
        if (!otroalmacengranelescheck) {
            setotroalmacengranelescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otroalmacengraneles')
        } else {
            setotroalmacengranelescheck(false)
            observaciones['otroalmacengraneles'] = ''
        }
    }
    const checkopcionotroalmacengranelescheck = () => {
        if (!opcionotroalmacengranelescheck) {
            setopcionotroalmacengranelescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotroalmacengraneles')
        } else {
            setopcionotroalmacengranelescheck(false)
            observaciones['opcionotroalmacengraneles'] = ''
        }
    }
    const checkcantidadotroalmacengranelescheck = () => {
        if (!cantidadotroalmacengranelescheck) {
            setcantidadotroalmacengranelescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotroalmacengraneles')
        } else {
            setcantidadotroalmacengranelescheck(false)
            observaciones['cantidadotroalmacengraneles'] = ''
        }
    }
    const checkcapacidadotroalmacengranelescheck = () => {
        if (!capacidadotroalmacengranelescheck) {
            setcapacidadotroalmacengranelescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadotroalmacengraneles')
        } else {
            setcapacidadotroalmacengranelescheck(false)
            observaciones['capacidadotroalmacengraneles'] = ''
        }
    }
    const checkfiltrocartuchocheck = () => {
        if (!filtrocartuchocheck) {
            setfiltrocartuchocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('filtrocartucho')
        } else {
            setfiltrocartuchocheck(false)
            observaciones['filtrocartucho'] = ''
        }
    }
    const checkcantidadfiltrocartuchocheck = () => {
        if (!cantidadfiltrocartuchocheck) {
            setcantidadfiltrocartuchocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadfiltrocartucho')
        } else {
            setcantidadfiltrocartuchocheck(false)
            observaciones['cantidadfiltrocartucho'] = ''
        }
    }
    const checkcaracteristicasfiltrocartuchocheck = () => {
        if (!caracteristicasfiltrocartuchocheck) {
            setcaracteristicasfiltrocartuchocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicasfiltrocartucho')
        } else {
            setcaracteristicasfiltrocartuchocheck(false)
            observaciones['caracteristicasfiltrocartucho'] = ''
        }
    }
    const checkfiltroprensacheck = () => {
        if (!filtroprensacheck) {
            setfiltroprensacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('filtroprensa')
        } else {
            setfiltroprensacheck(false)
            observaciones['filtroprensa'] = ''
        }
    }
    const checkcantidadfiltroprensacheck = () => {
        if (!cantidadfiltroprensacheck) {
            setcantidadfiltroprensacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadfiltroprensa')
        } else {
            setcantidadfiltroprensacheck(false)
            observaciones['cantidadfiltroprensa'] = ''
        }
    }
    const checkcaracteristicasfiltroprensacheck = () => {
        if (!caracteristicasfiltroprensacheck) {
            setcaracteristicasfiltroprensacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicasfiltroprensa')
        } else {
            setcaracteristicasfiltroprensacheck(false)
            observaciones['caracteristicasfiltroprensa'] = ''
        }
    }
    const checkotrofiltracionmezcalcheck = () => {
        if (!otrofiltracionmezcalcheck) {
            setotrofiltracionmezcalcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otrofiltracionmezcal')
        } else {
            setotrofiltracionmezcalcheck(false)
            observaciones['otrofiltracionmezcal'] = ''
        }
    }
    const checkopcionotrofiltracionmezcalcheck = () => {
        if (!opcionotrofiltracionmezcalcheck) {
            setopcionotrofiltracionmezcalcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotrofiltracionmezcal')
        } else {
            setopcionotrofiltracionmezcalcheck(false)
            observaciones['opcionotrofiltracionmezcal'] = ''
        }
    }
    const checkcantidadotrofiltracionmezcalcheck = () => {
        if (!cantidadotrofiltracionmezcalcheck) {
            setcantidadotrofiltracionmezcalcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotrofiltracionmezcal')
        } else {
            setcantidadotrofiltracionmezcalcheck(false)
            observaciones['cantidadotrofiltracionmezcal'] = ''
        }
    }
    const checkcaracteristicasotrofiltracionmecheck = () => {
        if (!caracteristicasotrofiltracionmecheck) {
            setcaracteristicasotrofiltracionmecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicasotrofiltracionme')
        } else {
            setcaracteristicasotrofiltracionmecheck(false)
            observaciones['caracteristicasotrofiltracionme'] = ''
        }
    }
    const checkllenadoramanualcheck = () => {
        if (!llenadoramanualcheck) {
            setllenadoramanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('llenadoramanual')
        } else {
            setllenadoramanualcheck(false)
            observaciones['llenadoramanual'] = ''
        }
    }
    const checkcantidadllenadoramanualcheck = () => {
        if (!cantidadllenadoramanualcheck) {
            setcantidadllenadoramanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadllenadoramanual')
        } else {
            setcantidadllenadoramanualcheck(false)
            observaciones['cantidadllenadoramanual'] = ''
        }
    }
    const checkcapacidadllenadoramanualcheck = () => {
        if (!capacidadllenadoramanualcheck) {
            setcapacidadllenadoramanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadllenadoramanual')
        } else {
            setcapacidadllenadoramanualcheck(false)
            observaciones['capacidadllenadoramanual'] = ''
        }
    }
    const checkllenadoraautomaticacheck = () => {
        if (!llenadoraautomaticacheck) {
            setllenadoraautomaticacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('llenadoraautomatica')
        } else {
            setllenadoraautomaticacheck(false)
            observaciones['llenadoraautomatica'] = ''
        }
    }
    const checkcantidadllenadoraautomaticacheck = () => {
        if (!cantidadllenadoraautomaticacheck) {
            setcantidadllenadoraautomaticacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadllenadoraautomatica')
        } else {
            setcantidadllenadoraautomaticacheck(false)
            observaciones['cantidadllenadoraautomatica'] = ''
        }
    }
    const checkcapacidadllenadoraautomaticacheck = () => {
        if (!capacidadllenadoraautomaticacheck) {
            setcapacidadllenadoraautomaticacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadllenadoraautomatica')
        } else {
            setcapacidadllenadoraautomaticacheck(false)
            observaciones['capacidadllenadoraautomatica'] = ''
        }
    }
    const checkotrollenadobotellascheck = () => {
        if (!otrollenadobotellascheck) {
            setotrollenadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otrollenadobotellas')
        } else {
            setotrollenadobotellascheck(false)
            observaciones['otrollenadobotellas'] = ''
        }
    }
    const checkopcionotrollenadobotellascheck = () => {
        if (!opcionotrollenadobotellascheck) {
            setopcionotrollenadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotrollenadobotellas')
        } else {
            setopcionotrollenadobotellascheck(false)
            observaciones['opcionotrollenadobotellas'] = ''
        }
    }
    const checkcantidadotrollenadobotellascheck = () => {
        if (!cantidadotrollenadobotellascheck) {
            setcantidadotrollenadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotrollenadobotellas')
        } else {
            setcantidadotrollenadobotellascheck(false)
            observaciones['cantidadotrollenadobotellas'] = ''
        }
    }
    const checkcapacidadotrollenadobotellascheck = () => {
        if (!capacidadotrollenadobotellascheck) {
            setcapacidadotrollenadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadotrollenadobotellas')
        } else {
            setcapacidadotrollenadobotellascheck(false)
            observaciones['capacidadotrollenadobotellas'] = ''
        }
    }
    const checktaponadomanualcheck = () => {
        if (!taponadomanualcheck) {
            settaponadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('taponadomanual')
        } else {
            settaponadomanualcheck(false)
            observaciones['taponadomanual'] = ''
        }
    }
    const checkcantidadtaponadomanualcheck = () => {
        if (!cantidadtaponadomanualcheck) {
            setcantidadtaponadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadtaponadomanual')
        } else {
            setcantidadtaponadomanualcheck(false)
            observaciones['cantidadtaponadomanual'] = ''
        }
    }
    const checkcapacidadtaponadomanualcheck = () => {
        if (!capacidadtaponadomanualcheck) {
            setcapacidadtaponadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadtaponadomanual')
        } else {
            setcapacidadtaponadomanualcheck(false)
            observaciones['capacidadtaponadomanual'] = ''
        }
    }
    const checktaponadoautomaticocheck = () => {
        if (!taponadoautomaticocheck) {
            settaponadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('taponadoautomatico')
        } else {
            settaponadoautomaticocheck(false)
            observaciones['taponadoautomatico'] = ''
        }
    }
    const checkcantidadtaponadoautomaticocheck = () => {
        if (!cantidadtaponadoautomaticocheck) {
            setcantidadtaponadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadtaponadoautomatico')
        } else {
            setcantidadtaponadoautomaticocheck(false)
            observaciones['cantidadtaponadoautomatico'] = ''
        }
    }
    const checkcapacidadtaponadoautomaticocheck = () => {
        if (!capacidadtaponadoautomaticocheck) {
            setcapacidadtaponadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadtaponadoautomatico')
        } else {
            setcapacidadtaponadoautomaticocheck(false)
            observaciones['capacidadtaponadoautomatico'] = ''
        }
    }
    const checkotrotaponadobotellascheck = () => {
        if (!otrotaponadobotellascheck) {
            setotrotaponadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otrotaponadobotellas')
        } else {
            setotrotaponadobotellascheck(false)
            observaciones['otrotaponadobotellas'] = ''
        }
    }
    const checkopcionotrotaponadobotellascheck = () => {
        if (!opcionotrotaponadobotellascheck) {
            setopcionotrotaponadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotrotaponadobotellas')
        } else {
            setopcionotrotaponadobotellascheck(false)
            observaciones['opcionotrotaponadobotellas'] = ''
        }
    }
    const checkcantidadotrotaponadobotellascheck = () => {
        if (!cantidadotrotaponadobotellascheck) {
            setcantidadotrotaponadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotrotaponadobotellas')
        } else {
            setcantidadotrotaponadobotellascheck(false)
            observaciones['cantidadotrotaponadobotellas'] = ''
        }
    }
    const checkcapacidadotrotaponadobotellascheck = () => {
        if (!capacidadotrotaponadobotellascheck) {
            setcapacidadotrotaponadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadotrotaponadobotellas')
        } else {
            setcapacidadotrotaponadobotellascheck(false)
            observaciones['capacidadotrotaponadobotellas'] = ''
        }
    }
    const checkselladomanualcheck = () => {
        if (!selladomanualcheck) {
            setselladomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('selladomanual')
        } else {
            setselladomanualcheck(false)
            observaciones['selladomanual'] = ''
        }
    }
    const checkcantidadselladomanualcheck = () => {
        if (!cantidadselladomanualcheck) {
            setcantidadselladomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadselladomanual')
        } else {
            setcantidadselladomanualcheck(false)
            observaciones['cantidadselladomanual'] = ''
        }
    }
    const checkcapacidadselladomanualcheck = () => {
        if (!capacidadselladomanualcheck) {
            setcapacidadselladomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadselladomanual')
        } else {
            setcapacidadselladomanualcheck(false)
            observaciones['capacidadselladomanual'] = ''
        }
    }
    const checkselladoautomaticocheck = () => {
        if (!selladoautomaticocheck) {
            setselladoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('selladoautomatico')
        } else {
            setselladoautomaticocheck(false)
            observaciones['selladoautomatico'] = ''
        }
    }
    const checkcantidadselladoautomaticocheck = () => {
        if (!cantidadselladoautomaticocheck) {
            setcantidadselladoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadselladoautomatico')
        } else {
            setcantidadselladoautomaticocheck(false)
            observaciones['cantidadselladoautomatico'] = ''
        }
    }
    const checkcapacidadselladoautomaticocheck = () => {
        if (!capacidadselladoautomaticocheck) {
            setcapacidadselladoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadselladoautomatico')
        } else {
            setcapacidadselladoautomaticocheck(false)
            observaciones['capacidadselladoautomatico'] = ''
        }
    }
    const checkotroselladobotellascheck = () => {
        if (!otroselladobotellascheck) {
            setotroselladobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otroselladobotellas')
        } else {
            setotroselladobotellascheck(false)
            observaciones['otroselladobotellas'] = ''
        }
    }
    const checkopcionotroselladobotellascheck = () => {
        if (!opcionotroselladobotellascheck) {
            setopcionotroselladobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotroselladobotellas')
        } else {
            setopcionotroselladobotellascheck(false)
            observaciones['opcionotroselladobotellas'] = ''
        }
    }
    const checkcantidadotroselladobotellascheck = () => {
        if (!cantidadotroselladobotellascheck) {
            setcantidadotroselladobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotroselladobotellas')
        } else {
            setcantidadotroselladobotellascheck(false)
            observaciones['cantidadotroselladobotellas'] = ''
        }
    }
    const checkcapacidadotroselladobotellascheck = () => {
        if (!capacidadotroselladobotellascheck) {
            setcapacidadotroselladobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadotroselladobotellas')
        } else {
            setcapacidadotroselladobotellascheck(false)
            observaciones['capacidadotroselladobotellas'] = ''
        }
    }
    const checketiquetadomanualcheck = () => {
        if (!etiquetadomanualcheck) {
            setetiquetadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('etiquetadomanual')
        } else {
            setetiquetadomanualcheck(false)
            observaciones['etiquetadomanual'] = ''
        }
    }
    const checkcantidadetiquetadomanualcheck = () => {
        if (!cantidadetiquetadomanualcheck) {
            setcantidadetiquetadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadetiquetadomanual')
        } else {
            setcantidadetiquetadomanualcheck(false)
            observaciones['cantidadetiquetadomanual'] = ''
        }
    }
    const checkcapacidadetiquetadomanualcheck = () => {
        if (!capacidadetiquetadomanualcheck) {
            setcapacidadetiquetadomanualcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadetiquetadomanual')
        } else {
            setcapacidadetiquetadomanualcheck(false)
            observaciones['capacidadetiquetadomanual'] = ''
        }
    }
    const checketiquetadoautomaticocheck = () => {
        if (!etiquetadoautomaticocheck) {
            setetiquetadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('etiquetadoautomatico')
        } else {
            setetiquetadoautomaticocheck(false)
            observaciones['etiquetadoautomatico'] = ''
        }
    }
    const checkcantidadetiquetadoautomaticocheck = () => {
        if (!cantidadetiquetadoautomaticocheck) {
            setcantidadetiquetadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadetiquetadoautomatico')
        } else {
            setcantidadetiquetadoautomaticocheck(false)
            observaciones['cantidadetiquetadoautomatico'] = ''
        }
    }
    const checkcapacidadetiquetadoautomaticocheck = () => {
        if (!capacidadetiquetadoautomaticocheck) {
            setcapacidadetiquetadoautomaticocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadetiquetadoautomatico')
        } else {
            setcapacidadetiquetadoautomaticocheck(false)
            observaciones['capacidadetiquetadoautomatico'] = ''
        }
    }
    const checkotroetiquetadobotellascheck = () => {
        if (!otroetiquetadobotellascheck) {
            setotroetiquetadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otroetiquetadobotellas')
        } else {
            setotroetiquetadobotellascheck(false)
            observaciones['otroetiquetadobotellas'] = ''
        }
    }
    const checkopcionotroetiquetadobotellascheck = () => {
        if (!opcionotroetiquetadobotellascheck) {
            setopcionotroetiquetadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionotroetiquetadobotellas')
        } else {
            setopcionotroetiquetadobotellascheck(false)
            observaciones['opcionotroetiquetadobotellas'] = ''
        }
    }
    const checkcantidadotroetiquetadobotellascheck = () => {
        if (!cantidadotroetiquetadobotellascheck) {
            setcantidadotroetiquetadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadotroetiquetadobotellas')
        } else {
            setcantidadotroetiquetadobotellascheck(false)
            observaciones['cantidadotroetiquetadobotellas'] = ''
        }
    }
    const checkcapacidadotroetiquetadobotellascheck = () => {
        if (!capacidadotroetiquetadobotellascheck) {
            setcapacidadotroetiquetadobotellascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadotroetiquetadobotellas')
        } else {
            setcapacidadotroetiquetadobotellascheck(false)
            observaciones['capacidadotroetiquetadobotellas'] = ''
        }
    }

    const [openModalObservaciones, setOpenModalObservaciones] = React.useState(false);
    const handleOpenModalObservaciones = () => setOpenModalObservaciones(true);
    const handleCloseModalObservaciones = () => setOpenModalObservaciones(false);


    const handleCloseModalObservacionesX = () => {
        setOpenModalObservaciones(false);
        desactivarCheck(campoParaObservacion);
    }

    const desactivarCheck = (campoADesactivar) => {
        switch (campoADesactivar) {
            case 'nombrerazonsocial': setnombrerazonsocialcheck(false); break;
            case 'altainstalaciones': setaltainstalacionescheck(false); break;
            case 'bajainstalaciones': setbajainstalacionescheck(false); break;
            case 'fechasolicitud': setfechasolicitudcheck(false); break;
            case 'fechapropuesta': setfechapropuestacheck(false); break;
            case 'instalacionnumero': setinstalacionnumerocheck(false); break;
            case 'tipoinstalacion': settipoinstalacioncheck(false); break;
            case 'alias': setaliascheck(false); break;
            case 'calle': setcallecheck(false); break;
            case 'numeroexterior': setnumeroexteriorcheck(false); break;
            case 'numerointerior': setnumerointeriorcheck(false); break;
            case 'colonia': setcoloniacheck(false); break;
            case 'localidad': setlocalidadcheck(false); break;
            case 'municipio': setmunicipiocheck(false); break;
            case 'estado': setestadocheck(false); break;
            case 'codigopostal': setcodigopostalcheck(false); break;
            case 'referenciascercanas': setreferenciascercanascheck(false); break;
            case 'telefono': settelefonocheck(false); break;
            case 'correoelectronico': setcorreoelectronicocheck(false); break;
            case 'nombreresponsable': setnombreresponsablecheck(false); break;
            case 'anforasplastico': setanforasplasticocheck(false); break;
            case 'cantidadanforasplastico': setcantidadanforasplasticocheck(false); break;
            case 'capacidadanforasplastico': setcapacidadanforasplasticocheck(false); break;
            case 'tambosplasticos': settambosplasticoscheck(false); break;
            case 'cantidadtambosplasticos': setcantidadtambosplasticoscheck(false); break;
            case 'capacidadtambosplasticos': setcapacidadtambosplasticoscheck(false); break;
            case 'contenedoresplastico1000': setcontenedoresplastico1000check(false); break;
            case 'cantidadcontplastico100': setcantidadcontplastico100check(false); break;
            case 'capacidadcontplastico10': setcapacidadcontplastico10check(false); break;
            case 'contenedoresplastico10000': setcontenedoresplastico1000check(false); break;
            case 'cantidadcontplastico1000': setcantidadcontplastico1000check(false); break;
            case 'capacidadcontplastico100': setcapacidadcontplastico100check(false); break;
            case 'recipientesaceroinoxidable': setrecipientesaceroinoxidablecheck(false); break;
            case 'cantidadrecaceroinoxida': setcantidadrecaceroinoxidacheck(false); break;
            case 'capacidadrecaceroinoxid': setcapacidadrecaceroinoxidcheck(false); break;
            case 'otroalmacengraneles': setotroalmacengranelescheck(false); break;
            case 'opcionotroalmacengraneles': setopcionotroalmacengranelescheck(false); break;
            case 'cantidadotroalmacengraneles': setcantidadotroalmacengranelescheck(false); break;
            case 'capacidadotroalmacengraneles': setcapacidadotroalmacengranelescheck(false); break;
            case 'filtrocartucho': setfiltrocartuchocheck(false); break;
            case 'cantidadfiltrocartucho': setcantidadfiltrocartuchocheck(false); break;
            case 'caracteristicasfiltrocartucho': setcaracteristicasfiltrocartuchocheck(false); break;
            case 'filtroprensa': setfiltroprensacheck(false); break;
            case 'cantidadfiltroprensa': setcantidadfiltroprensacheck(false); break;
            case 'caracteristicasfiltroprensa': setcaracteristicasfiltroprensacheck(false); break;
            case 'otrofiltracionmezcal': setotrofiltracionmezcalcheck(false); break;
            case 'opcionotrofiltracionmezcal': setopcionotrofiltracionmezcalcheck(false); break;
            case 'cantidadotrofiltracionmezcal': setcantidadotrofiltracionmezcalcheck(false); break;
            case 'caracteristicasotrofiltracionme': setcaracteristicasotrofiltracionmecheck(false); break;
            case 'llenadoramanual': setllenadoramanualcheck(false); break;
            case 'cantidadllenadoramanual': setcantidadllenadoramanualcheck(false); break;
            case 'capacidadllenadoramanual': setcapacidadllenadoramanualcheck(false); break;
            case 'llenadoraautomatica': setllenadoraautomaticacheck(false); break;
            case 'cantidadllenadoraautomatica': setcantidadllenadoraautomaticacheck(false); break;
            case 'capacidadllenadoraautomatica': setcapacidadllenadoraautomaticacheck(false); break;
            case 'otrollenadobotellas': setopcionotrollenadobotellascheck(false); break;
            case 'opcionotrollenadobotellas': setopcionotrollenadobotellascheck(false); break;
            case 'cantidadotrollenadobotellas': setcantidadotrollenadobotellascheck(false); break;
            case 'capacidadotrollenadobotellas': setcapacidadotrollenadobotellascheck(false); break;
            case 'taponadomanual': setcantidadtaponadomanualcheck(false); break;
            case 'cantidadtaponadomanual': setcantidadtaponadomanualcheck(false); break;
            case 'capacidadtaponadomanual': setcapacidadtaponadomanualcheck(false); break;
            case 'taponadoautomatico': settaponadoautomaticocheck(false); break;
            case 'cantidadtaponadoautomatico': setcantidadtaponadoautomaticocheck(false); break;
            case 'capacidadtaponadoautomatico': setcapacidadtaponadoautomaticocheck(false); break;
            case 'otrotaponadobotellas': setotrotaponadobotellascheck(false); break;
            case 'opcionotrotaponadobotellas': setopcionotrotaponadobotellascheck(false); break;
            case 'cantidadotrotaponadobotellas': setcantidadotrotaponadobotellascheck(false); break;
            case 'capacidadotrotaponadobotellas': setcapacidadotrotaponadobotellascheck(false); break;
            case 'selladomanual': setselladomanualcheck(false); break;
            case 'cantidadselladomanual': setcantidadselladomanualcheck(false); break;
            case 'capacidadselladomanual': setcapacidadselladomanualcheck(false); break;
            case 'selladoautomatico': setselladoautomaticocheck(false); break;
            case 'cantidadselladoautomatico': setcantidadselladoautomaticocheck(false); break;
            case 'capacidadselladoautomatico': setcapacidadselladoautomaticocheck(false); break;
            case 'otroselladobotellas': setotroselladobotellascheck(false); break;
            case 'opcionotroselladobotellas': setopcionotroselladobotellascheck(false); break;
            case 'cantidadotroselladobotellas': setcantidadotroselladobotellascheck(false); break;
            case 'capacidadotroselladobotellas': setcapacidadotroselladobotellascheck(false); break;
            case 'etiquetadomanual': setetiquetadomanualcheck(false); break;
            case 'cantidadetiquetadomanual': setcantidadetiquetadomanualcheck(false); break;
            case 'capacidadetiquetadomanual': setcapacidadetiquetadomanualcheck(false); break;
            case 'etiquetadoautomatico': setetiquetadoautomaticocheck(false); break;
            case 'cantidadetiquetadoautomatico': setcantidadetiquetadoautomaticocheck(false); break;
            case 'capacidadetiquetadoautomatico': setcapacidadotroetiquetadobotellascheck(false); break;
            case 'otroetiquetadobotellas': setotroetiquetadobotellascheck(false); break;
            case 'opcionotroetiquetadobotellas': setopcionotroetiquetadobotellascheck(false); break;
            case 'cantidadotroetiquetadobotellas': setcantidadotroetiquetadobotellascheck(false); break;
            case 'capacidadotroetiquetadobotellas': setcapacidadotroetiquetadobotellascheck(false); break;

        }
        setObservacionArea('')
        setCampoParaObservacion('')

    }



    const [observacionArea, setObservacionArea] = useStateIfMounted('')
    let [campoParaObservacion, setCampoParaObservacion] = useStateIfMounted('')
    const mostrarModal = (campo) => {
        setCampoParaObservacion(campo)
    }
    const modalComponentObservaciones = (campo) => {
        return (
            <Fragment>
                <Modal
                    open={openModalObservaciones}
                    onClose={handleCloseModalObservacionesX}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disableEnforceFocus
                >
                    <Box sx={style}>
                        <div className={`${estilos.textRight}`}>
                            <button className='btn' onClick={handleCloseModalObservacionesX}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        </div>
                        <div align="center">
                            <label align="center"> <b>OBSERVACIONES</b></label>
                        </div>
                        <textarea type="textarea" rows="3" className="form-control"
                            placeholder='Detalle de la observacion.'
                            value={observacionArea} onChange={e => setObservacionArea(e.target.value)} />

                        <br />
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                            <button className='btn btn-dark' onClick={e => botonGuardarObservaciones(observacionArea)}>Aceptar</button>
                        </div>

                    </Box>
                </Modal>
            </Fragment>

        )
    }
    const botonGuardarObservaciones = async (observacion) => {
        observaciones[campoParaObservacion] = observacion
        handleCloseModalObservaciones()
        setObservacionArea('')
        setCampoParaObservacion('')
    }


    React.useEffect(() => {
        if (anexoEnvasadoFormato.length > 0) {
            setnocliente(anexoEnvasadoFormato[0].nocliente)
            setnombrerazonsocialenvasado(anexoEnvasadoFormato[0].nombrerazonsocial)
            setaltainstalacionesenvasado(anexoEnvasadoFormato[0].altainstalaciones)
            setbajainstalacionesenvasado(anexoEnvasadoFormato[0].bajainstalaciones)
            setfechasolicitudenvasado(anexoEnvasadoFormato[0].fechasolicitud)
            setfechapropuestaenvasado(anexoEnvasadoFormato[0].fechapropuesta)
            setinstalacionnumeroenvasado(anexoEnvasadoFormato[0].instalacionnumero)
            settipoinstalacionenvasado(anexoEnvasadoFormato[0].tipoinstalacion)
            setaliasenvasado(anexoEnvasadoFormato[0].alias)
            setcalleenvasado(anexoEnvasadoFormato[0].calle)
            setnumeroexteriorenvasado(anexoEnvasadoFormato[0].numeroexterior)
            setnumerointeriorenvasado(anexoEnvasadoFormato[0].numerointerior)
            setcoloniaenvasado(anexoEnvasadoFormato[0].colonia)
            setlocalidadenvasado(anexoEnvasadoFormato[0].localidad)
            setmunicipioenvasado(anexoEnvasadoFormato[0].municipio)
            setestadoenvasado(anexoEnvasadoFormato[0].estado)
            setcodigopostalenvasado(anexoEnvasadoFormato[0].codigopostal)
            setreferenciascercanasenvasado(anexoEnvasadoFormato[0].referenciascercanas)
            settelefonoenvasado(anexoEnvasadoFormato[0].telefono)
            setcorreoelectronicoenvasado(anexoEnvasadoFormato[0].correoelectronico)
            setnombreresponsableenvasado(anexoEnvasadoFormato[0].nombreresponsable)
            setanforasplasticoenvasado(anexoEnvasadoFormato[0].anforasplastico)
            setcantidadanforasplasticoenvasado(anexoEnvasadoFormato[0].cantidadanforasplastico)
            setcapacidadanforasplasticoenvasado(anexoEnvasadoFormato[0].capacidadanforasplastico)
            settambosplasticosenvasado(anexoEnvasadoFormato[0].tambosplasticos)
            setcantidadtambosplasticosenvasado(anexoEnvasadoFormato[0].cantidadtambosplasticos)
            setcapacidadtambosplasticosenvasado(anexoEnvasadoFormato[0].capacidadtambosplasticos)
            setcontenedoresplastico1000envasado(anexoEnvasadoFormato[0].contenedoresplastico1000)
            setcantidadcontenedoresplastico100envasado(anexoEnvasadoFormato[0].cantidadcontenedoresplastico100)
            setcapacidadcontenedoresplastico10envasado(anexoEnvasadoFormato[0].capacidadcontenedoresplastico10)
            setcontenedoresplastico5000envasado(anexoEnvasadoFormato[0].contenedoresplastico5000)
            setcantidadcontenedoresplastico500envasado(anexoEnvasadoFormato[0].cantidadcontenedoresplastico500)
            setcapacidadcontenedoresplastico50envasado(anexoEnvasadoFormato[0].capacidadcontenedoresplastico50)
            setrecipientesaceroinoxidableenvasado(anexoEnvasadoFormato[0].recipientesaceroinoxidable)
            setcantidadrecipientesaceroinoxidaenvasado(anexoEnvasadoFormato[0].cantidadrecipientesaceroinoxida)
            setcapacidadrecipientesaceroinoxidenvasado(anexoEnvasadoFormato[0].capacidadrecipientesaceroinoxid)
            setotroalmacengranelesenvasado(anexoEnvasadoFormato[0].otroalmacengraneles)
            setopcionotroalmacengranelesenvasado(anexoEnvasadoFormato[0].opcionotroalmacengraneles)
            setcantidadotroalmacengranelesenvasado(anexoEnvasadoFormato[0].cantidadotroalmacengraneles)
            setcapacidadotroalmacengranelesenvasado(anexoEnvasadoFormato[0].capacidadotroalmacengraneles)
            setfiltrocartucho(anexoEnvasadoFormato[0].filtrocartucho)
            setcantidadfiltrocartucho(anexoEnvasadoFormato[0].cantidadfiltrocartucho)
            setcaracteristicasfiltrocartucho(anexoEnvasadoFormato[0].caracteristicasfiltrocartucho)
            setfiltroprensa(anexoEnvasadoFormato[0].filtroprensa)
            setcantidadfiltroprensa(anexoEnvasadoFormato[0].cantidadfiltroprensa)
            setcaracteristicasfiltroprensa(anexoEnvasadoFormato[0].caracteristicasfiltroprensa)
            setotrofiltracionmezcal(anexoEnvasadoFormato[0].otrofiltracionmezcal)
            setopcionotrofiltracionmezcal(anexoEnvasadoFormato[0].opcionotrofiltracionmezcal)
            setcantidadotrofiltracionmezcal(anexoEnvasadoFormato[0].cantidadotrofiltracionmezcal)
            setcaracteristicasotrofiltracionme(anexoEnvasadoFormato[0].caracteristicasotrofiltracionme)
            setllenadoramanual(anexoEnvasadoFormato[0].llenadoramanual)
            setcantidadllenadoramanual(anexoEnvasadoFormato[0].cantidadllenadoramanual)
            setcapacidadllenadoramanual(anexoEnvasadoFormato[0].capacidadllenadoramanual)
            setllenadoraautomatica(anexoEnvasadoFormato[0].llenadoraautomatica)
            setcantidadllenadoraautomatica(anexoEnvasadoFormato[0].cantidadllenadoraautomatica)
            setcapacidadllenadoraautomatica(anexoEnvasadoFormato[0].capacidadllenadoraautomatica)
            setotrollenadobotellas(anexoEnvasadoFormato[0].otrollenadobotellas)
            setopcionotrollenadobotellas(anexoEnvasadoFormato[0].opcionotrollenadobotellas)
            setcantidadotrollenadobotellas(anexoEnvasadoFormato[0].cantidadotrollenadobotellas)
            setcapacidadotrollenadobotellas(anexoEnvasadoFormato[0].capacidadotrollenadobotellas)
            settaponadomanual(anexoEnvasadoFormato[0].taponadomanual)
            setcantidadtaponadomanual(anexoEnvasadoFormato[0].cantidadtaponadomanual)
            setcapacidadtaponadomanual(anexoEnvasadoFormato[0].capacidadtaponadomanual)
            settaponadoautomatico(anexoEnvasadoFormato[0].taponadoautomatico)
            setcantidadtaponadoautomatico(anexoEnvasadoFormato[0].cantidadtaponadoautomatico)
            setcapacidadtaponadoautomatico(anexoEnvasadoFormato[0].capacidadtaponadoautomatico)
            setotrotaponadobotellas(anexoEnvasadoFormato[0].otrotaponadobotellas)
            setopcionotrotaponadobotellas(anexoEnvasadoFormato[0].opcionotrotaponadobotellas)
            setcantidadotrotaponadobotellas(anexoEnvasadoFormato[0].cantidadotrotaponadobotellas)
            setcapacidadotrotaponadobotellas(anexoEnvasadoFormato[0].capacidadotrotaponadobotellas)
            setselladomanual(anexoEnvasadoFormato[0].selladomanual)
            setcantidadselladomanual(anexoEnvasadoFormato[0].cantidadselladomanual)
            setcapacidadselladomanual(anexoEnvasadoFormato[0].capacidadselladomanual)
            setselladoautomatico(anexoEnvasadoFormato[0].selladoautomatico)
            setcantidadselladoautomatico(anexoEnvasadoFormato[0].cantidadselladoautomatico)
            setcapacidadselladoautomatico(anexoEnvasadoFormato[0].capacidadselladoautomatico)
            setotroselladobotellas(anexoEnvasadoFormato[0].otroselladobotellas)
            setopcionotroselladobotellas(anexoEnvasadoFormato[0].opcionotroselladobotellas)
            setcantidadotroselladobotellas(anexoEnvasadoFormato[0].cantidadotroselladobotellas)
            setcapacidadotroselladobotellas(anexoEnvasadoFormato[0].capacidadotroselladobotellas)
            setetiquetadomanual(anexoEnvasadoFormato[0].etiquetadomanual)
            setcantidadetiquetadomanual(anexoEnvasadoFormato[0].cantidadetiquetadomanual)
            setcapacidadetiquetadomanual(anexoEnvasadoFormato[0].capacidadetiquetadomanual)
            setetiquetadoautomatico(anexoEnvasadoFormato[0].etiquetadoautomatico)
            setcantidadetiquetadoautomatico(anexoEnvasadoFormato[0].cantidadetiquetadoautomatico)
            setcapacidadetiquetadoautomatico(anexoEnvasadoFormato[0].capacidadetiquetadoautomatico)
            setotroetiquetadobotellas(anexoEnvasadoFormato[0].otroetiquetadobotellas)
            setopcionotroetiquetadobotellas(anexoEnvasadoFormato[0].opcionotroetiquetadobotellas)
            setcantidadotroetiquetadobotellas(anexoEnvasadoFormato[0].cantidadotroetiquetadobotellas)
            setcapacidadotroetiquetadobotellas(anexoEnvasadoFormato[0].capacidadotroetiquetadobotellas)
        }

    }, [])
    React.useEffect(() => {
        if (!(JSON.stringify([]) === JSON.stringify(anexoUnidadEnvasadoMap))) {
            setnombrerazonsocialcheck(anexoUnidadEnvasadoMap.nombrerazonsocialcheck)
            setaltainstalacionescheck(anexoUnidadEnvasadoMap.altainstalacionescheck)
            setbajainstalacionescheck(anexoUnidadEnvasadoMap.bajainstalacionescheck)
            setfechasolicitudcheck(anexoUnidadEnvasadoMap.fechasolicitudcheck)
            setfechapropuestacheck(anexoUnidadEnvasadoMap.fechapropuestacheck)
            setinstalacionnumerocheck(anexoUnidadEnvasadoMap.instalacionnumerocheck)
            settipoinstalacioncheck(anexoUnidadEnvasadoMap.tipoinstalacioncheck)
            setaliascheck(anexoUnidadEnvasadoMap.aliascheck)
            setcallecheck(anexoUnidadEnvasadoMap.callecheck)
            setnumeroexteriorcheck(anexoUnidadEnvasadoMap.numeroexteriorcheck)
            setnumerointeriorcheck(anexoUnidadEnvasadoMap.numerointeriorcheck)
            setcoloniacheck(anexoUnidadEnvasadoMap.coloniacheck)
            setlocalidadcheck(anexoUnidadEnvasadoMap.localidadcheck)
            setmunicipiocheck(anexoUnidadEnvasadoMap.municipiocheck)
            setestadocheck(anexoUnidadEnvasadoMap.estadocheck)
            setcodigopostalcheck(anexoUnidadEnvasadoMap.codigopostalcheck)
            setreferenciascercanascheck(anexoUnidadEnvasadoMap.referenciascercanascheck)
            settelefonocheck(anexoUnidadEnvasadoMap.telefonocheck)
            setcorreoelectronicocheck(anexoUnidadEnvasadoMap.correoelectronicocheck)
            setnombreresponsablecheck(anexoUnidadEnvasadoMap.nombreresponsablecheck)
            setanforasplasticocheck(anexoUnidadEnvasadoMap.anforasplasticocheck)
            setcantidadanforasplasticocheck(anexoUnidadEnvasadoMap.cantidadanforasplasticocheck)
            setcapacidadanforasplasticocheck(anexoUnidadEnvasadoMap.capacidadanforasplasticocheck)
            settambosplasticoscheck(anexoUnidadEnvasadoMap.tambosplasticoscheck)
            setcantidadtambosplasticoscheck(anexoUnidadEnvasadoMap.cantidadtambosplasticoscheck)
            setcapacidadtambosplasticoscheck(anexoUnidadEnvasadoMap.capacidadtambosplasticoscheck)
            setcontenedoresplastico1000check(anexoUnidadEnvasadoMap.contenedoresplastico1000check)
            setcantidadcontplastico100check(anexoUnidadEnvasadoMap.cantidadcontplastico100check)
            setcapacidadcontplastico10check(anexoUnidadEnvasadoMap.capacidadcontplastico10check)
            setcontenedoresplastico10000check(anexoUnidadEnvasadoMap.contenedoresplastico10000check)
            setcantidadcontplastico1000check(anexoUnidadEnvasadoMap.cantidadcontplastico1000check)
            setcapacidadcontplastico100check(anexoUnidadEnvasadoMap.capacidadcontplastico100check)
            setrecipientesaceroinoxidablecheck(anexoUnidadEnvasadoMap.recipientesaceroinoxidablecheck)
            setcantidadrecaceroinoxidacheck(anexoUnidadEnvasadoMap.cantidadrecaceroinoxidacheck)
            setcapacidadrecaceroinoxidcheck(anexoUnidadEnvasadoMap.capacidadrecaceroinoxidcheck)
            setotroalmacengranelescheck(anexoUnidadEnvasadoMap.otroalmacengranelescheck)
            setopcionotroalmacengranelescheck(anexoUnidadEnvasadoMap.opcionotroalmacengranelescheck)
            setcantidadotroalmacengranelescheck(anexoUnidadEnvasadoMap.cantidadotroalmacengranelescheck)
            setcapacidadotroalmacengranelescheck(anexoUnidadEnvasadoMap.capacidadotroalmacengranelescheck)
            setfiltrocartuchocheck(anexoUnidadEnvasadoMap.filtrocartuchocheck)
            setcantidadfiltrocartuchocheck(anexoUnidadEnvasadoMap.cantidadfiltrocartuchocheck)
            setcaracteristicasfiltrocartuchocheck(anexoUnidadEnvasadoMap.caracteristicasfiltrocartuchocheck)
            setfiltroprensacheck(anexoUnidadEnvasadoMap.filtroprensacheck)
            setcantidadfiltroprensacheck(anexoUnidadEnvasadoMap.cantidadfiltroprensacheck)
            setcaracteristicasfiltroprensacheck(anexoUnidadEnvasadoMap.caracteristicasfiltroprensacheck)
            setotrofiltracionmezcalcheck(anexoUnidadEnvasadoMap.otrofiltracionmezcalcheck)
            setopcionotrofiltracionmezcalcheck(anexoUnidadEnvasadoMap.opcionotrofiltracionmezcalcheck)
            setcantidadotrofiltracionmezcalcheck(anexoUnidadEnvasadoMap.cantidadotrofiltracionmezcalcheck)
            setcaracteristicasotrofiltracionmecheck(anexoUnidadEnvasadoMap.caracteristicasotrofiltracionmecheck)
            setllenadoramanualcheck(anexoUnidadEnvasadoMap.llenadoramanualcheck)
            setcantidadllenadoramanualcheck(anexoUnidadEnvasadoMap.cantidadllenadoramanualcheck)
            setcapacidadllenadoramanualcheck(anexoUnidadEnvasadoMap.capacidadllenadoramanualcheck)
            setllenadoraautomaticacheck(anexoUnidadEnvasadoMap.llenadoraautomaticacheck)
            setcantidadllenadoraautomaticacheck(anexoUnidadEnvasadoMap.cantidadllenadoraautomaticacheck)
            setcapacidadllenadoraautomaticacheck(anexoUnidadEnvasadoMap.capacidadllenadoraautomaticacheck)
            setotrollenadobotellascheck(anexoUnidadEnvasadoMap.otrollenadobotellascheck)
            setopcionotrollenadobotellascheck(anexoUnidadEnvasadoMap.opcionotrollenadobotellascheck)
            setcantidadotrollenadobotellascheck(anexoUnidadEnvasadoMap.cantidadotrollenadobotellascheck)
            setcapacidadotrollenadobotellascheck(anexoUnidadEnvasadoMap.capacidadotrollenadobotellascheck)
            settaponadomanualcheck(anexoUnidadEnvasadoMap.taponadomanualcheck)
            setcantidadtaponadomanualcheck(anexoUnidadEnvasadoMap.cantidadtaponadomanualcheck)
            setcapacidadtaponadomanualcheck(anexoUnidadEnvasadoMap.capacidadtaponadomanualcheck)
            settaponadoautomaticocheck(anexoUnidadEnvasadoMap.taponadoautomaticocheck)
            setcantidadtaponadoautomaticocheck(anexoUnidadEnvasadoMap.cantidadtaponadoautomaticocheck)
            setcapacidadtaponadoautomaticocheck(anexoUnidadEnvasadoMap.capacidadtaponadoautomaticocheck)
            setotrotaponadobotellascheck(anexoUnidadEnvasadoMap.otrotaponadobotellascheck)
            observaciones.nombrerazonsocial = anexoUnidadEnvasadoMap.nombrerazonsocial
            observaciones.altainstalaciones = anexoUnidadEnvasadoMap.altainstalaciones
            observaciones.bajainstalaciones = anexoUnidadEnvasadoMap.bajainstalaciones
            observaciones.fechasolicitud = anexoUnidadEnvasadoMap.fechasolicitud
            observaciones.fechapropuesta = anexoUnidadEnvasadoMap.fechapropuesta
            observaciones.instalacionnumero = anexoUnidadEnvasadoMap.instalacionnumero
            observaciones.tipoinstalacion = anexoUnidadEnvasadoMap.tipoinstalacion
            observaciones.alias = anexoUnidadEnvasadoMap.alias
            observaciones.calle = anexoUnidadEnvasadoMap.calle
            observaciones.numeroexterior = anexoUnidadEnvasadoMap.numeroexterior
            observaciones.numerointerior = anexoUnidadEnvasadoMap.numerointerior
            observaciones.colonia = anexoUnidadEnvasadoMap.colonia
            observaciones.localidad = anexoUnidadEnvasadoMap.localidad
            observaciones.municipio = anexoUnidadEnvasadoMap.municipio
            observaciones.estado = anexoUnidadEnvasadoMap.estado
            observaciones.codigopostal = anexoUnidadEnvasadoMap.codigopostal
            observaciones.referenciascercanas = anexoUnidadEnvasadoMap.referenciascercanas
            observaciones.telefono = anexoUnidadEnvasadoMap.telefono
            observaciones.correoelectronico = anexoUnidadEnvasadoMap.correoelectronico
            observaciones.nombreresponsable = anexoUnidadEnvasadoMap.nombreresponsable
            observaciones.anforasplastico = anexoUnidadEnvasadoMap.anforasplastico
            observaciones.cantidadanforasplastico = anexoUnidadEnvasadoMap.cantidadanforasplastico
            observaciones.capacidadanforasplastico = anexoUnidadEnvasadoMap.capacidadanforasplastico
            observaciones.tambosplasticos = anexoUnidadEnvasadoMap.tambosplasticos
            observaciones.cantidadtambosplasticos = anexoUnidadEnvasadoMap.cantidadtambosplasticos
            observaciones.capacidadtambosplasticos = anexoUnidadEnvasadoMap.capacidadtambosplasticos
            observaciones.contenedoresplastico1000 = anexoUnidadEnvasadoMap.contenedoresplastico1000
            observaciones.cantidadcontplastico100 = anexoUnidadEnvasadoMap.cantidadcontplastico100
            observaciones.capacidadcontplastico10 = anexoUnidadEnvasadoMap.capacidadcontplastico10
            observaciones.contenedoresplastico10000 = anexoUnidadEnvasadoMap.contenedoresplastico10000
            observaciones.cantidadcontplastico1000 = anexoUnidadEnvasadoMap.cantidadcontplastico1000
            observaciones.capacidadcontplastico100 = anexoUnidadEnvasadoMap.capacidadcontplastico100
            observaciones.recipientesaceroinoxidable = anexoUnidadEnvasadoMap.recipientesaceroinoxidable
            observaciones.cantidadrecaceroinoxida = anexoUnidadEnvasadoMap.cantidadrecaceroinoxida
            observaciones.capacidadrecaceroinoxid = anexoUnidadEnvasadoMap.capacidadrecaceroinoxid
            observaciones.otroalmacengraneles = anexoUnidadEnvasadoMap.otroalmacengraneles
            observaciones.opcionotroalmacengraneles = anexoUnidadEnvasadoMap.opcionotroalmacengraneles
            observaciones.cantidadotroalmacengraneles = anexoUnidadEnvasadoMap.cantidadotroalmacengraneles
            observaciones.capacidadotroalmacengraneles = anexoUnidadEnvasadoMap.capacidadotroalmacengraneles
            observaciones.filtrocartucho = anexoUnidadEnvasadoMap.filtrocartucho
            observaciones.cantidadfiltrocartucho = anexoUnidadEnvasadoMap.cantidadfiltrocartucho
            observaciones.caracteristicasfiltrocartucho = anexoUnidadEnvasadoMap.caracteristicasfiltrocartucho
            observaciones.filtroprensa = anexoUnidadEnvasadoMap.filtroprensa
            observaciones.cantidadfiltroprensa = anexoUnidadEnvasadoMap.cantidadfiltroprensa
            observaciones.caracteristicasfiltroprensa = anexoUnidadEnvasadoMap.caracteristicasfiltroprensa
            observaciones.otrofiltracionmezcal = anexoUnidadEnvasadoMap.otrofiltracionmezcal
            observaciones.opcionotrofiltracionmezcal = anexoUnidadEnvasadoMap.opcionotrofiltracionmezcal
            observaciones.cantidadotrofiltracionmezcal = anexoUnidadEnvasadoMap.cantidadotrofiltracionmezcal
            observaciones.caracteristicasotrofiltracionme = anexoUnidadEnvasadoMap.caracteristicasotrofiltracionme
            observaciones.llenadoramanual = anexoUnidadEnvasadoMap.llenadoramanual
            observaciones.cantidadllenadoramanual = anexoUnidadEnvasadoMap.cantidadllenadoramanual
            observaciones.capacidadllenadoramanual = anexoUnidadEnvasadoMap.capacidadllenadoramanual
            observaciones.llenadoraautomatica = anexoUnidadEnvasadoMap.llenadoraautomatica
            observaciones.cantidadllenadoraautomatica = anexoUnidadEnvasadoMap.cantidadllenadoraautomatica
            observaciones.capacidadllenadoraautomatica = anexoUnidadEnvasadoMap.capacidadllenadoraautomatica
            observaciones.otrollenadobotellas = anexoUnidadEnvasadoMap.otrollenadobotellas
            observaciones.opcionotrollenadobotellas = anexoUnidadEnvasadoMap.opcionotrollenadobotellas
            observaciones.cantidadotrollenadobotellas = anexoUnidadEnvasadoMap.cantidadotrollenadobotellas
            observaciones.capacidadotrollenadobotellas = anexoUnidadEnvasadoMap.capacidadotrollenadobotellas
            observaciones.taponadomanual = anexoUnidadEnvasadoMap.taponadomanual
            observaciones.cantidadtaponadomanual = anexoUnidadEnvasadoMap.cantidadtaponadomanual
            observaciones.capacidadtaponadomanual = anexoUnidadEnvasadoMap.capacidadtaponadomanual
            observaciones.taponadoautomatico = anexoUnidadEnvasadoMap.taponadoautomatico
            observaciones.cantidadtaponadoautomatico = anexoUnidadEnvasadoMap.cantidadtaponadoautomatico
            observaciones.capacidadtaponadoautomatico = anexoUnidadEnvasadoMap.capacidadtaponadoautomatico
            observaciones.otrotaponadobotellas = anexoUnidadEnvasadoMap.otrotaponadobotellas
            observaciones.opcionotrotaponadobotellas = anexoUnidadEnvasadoMap.opcionotrotaponadobotellas
            observaciones.cantidadotrotaponadobotellas = anexoUnidadEnvasadoMap.cantidadotrotaponadobotellas
            observaciones.capacidadotrotaponadobotellas = anexoUnidadEnvasadoMap.capacidadotrotaponadobotellas
            observaciones.selladomanual = anexoUnidadEnvasadoMap.selladomanual
            observaciones.cantidadselladomanual = anexoUnidadEnvasadoMap.cantidadselladomanual
            observaciones.capacidadselladomanual = anexoUnidadEnvasadoMap.capacidadselladomanual
            observaciones.selladoautomatico = anexoUnidadEnvasadoMap.selladoautomatico
            observaciones.cantidadselladoautomatico = anexoUnidadEnvasadoMap.cantidadselladoautomatico
            observaciones.capacidadselladoautomatico = anexoUnidadEnvasadoMap.capacidadselladoautomatico
            observaciones.otroselladobotellas = anexoUnidadEnvasadoMap.otroselladobotellas
            observaciones.opcionotroselladobotellas = anexoUnidadEnvasadoMap.opcionotroselladobotellas
            observaciones.cantidadotroselladobotellas = anexoUnidadEnvasadoMap.cantidadotroselladobotellas
            observaciones.capacidadotroselladobotellas = anexoUnidadEnvasadoMap.capacidadotroselladobotellas
            observaciones.etiquetadomanual = anexoUnidadEnvasadoMap.etiquetadomanual
            observaciones.cantidadetiquetadomanual = anexoUnidadEnvasadoMap.cantidadetiquetadomanual
            observaciones.capacidadetiquetadomanual = anexoUnidadEnvasadoMap.capacidadetiquetadomanual
            observaciones.etiquetadoautomatico = anexoUnidadEnvasadoMap.etiquetadoautomatico
            observaciones.cantidadetiquetadoautomatico = anexoUnidadEnvasadoMap.cantidadetiquetadoautomatico
            observaciones.capacidadetiquetadoautomatico = anexoUnidadEnvasadoMap.capacidadetiquetadoautomatico
            observaciones.otroetiquetadobotellas = anexoUnidadEnvasadoMap.otroetiquetadobotellas
            observaciones.opcionotroetiquetadobotellas = anexoUnidadEnvasadoMap.opcionotroetiquetadobotellas
            observaciones.cantidadotroetiquetadobotellas = anexoUnidadEnvasadoMap.cantidadotroetiquetadobotellas
            observaciones.capacidadotroetiquetadobotellas = anexoUnidadEnvasadoMap.capacidadotroetiquetadobotellas
        }
    }, [])

    const botonEditarAnexoEnvasado = async () => {
        await dispatch(editarFC_36AnexoUnidadEnvasado({
            id: idEditable,
            nocliente, nombrerazonsocial, altainstalaciones, bajainstalaciones,
            fechasolicitud, fechapropuesta, instalacionnumero,
            tipoinstalacion, alias, calle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado,
            codigopostal, referenciascercanas, telefono, correoelectronico,
            nombreresponsable, anforasplastico, cantidadanforasplastico,
            capacidadanforasplastico, tambosplasticos, cantidadtambosplasticos,
            capacidadtambosplasticos, contenedoresplastico1000,
            cantidadcontenedoresplastico100, capacidadcontenedoresplastico10,
            contenedoresplastico5000, cantidadcontenedoresplastico500,
            capacidadcontenedoresplastico50, recipientesaceroinoxidable,
            cantidadrecipientesaceroinoxida, capacidadrecipientesaceroinoxid,
            otroalmacengraneles, opcionotroalmacengraneles,
            cantidadotroalmacengraneles, capacidadotroalmacengraneles, filtrocartucho,
            cantidadfiltrocartucho, caracteristicasfiltrocartucho, filtroprensa, cantidadfiltroprensa,
            caracteristicasfiltroprensa, otrofiltracionmezcal, opcionotrofiltracionmezcal,
            cantidadotrofiltracionmezcal, caracteristicasotrofiltracionme, llenadoramanual,
            cantidadllenadoramanual, capacidadllenadoramanual, llenadoraautomatica,
            cantidadllenadoraautomatica, capacidadllenadoraautomatica, otrollenadobotellas,
            opcionotrollenadobotellas, cantidadotrollenadobotellas, capacidadotrollenadobotellas,
            taponadomanual, cantidadtaponadomanual, capacidadtaponadomanual, taponadoautomatico,
            cantidadtaponadoautomatico, capacidadtaponadoautomatico, otrotaponadobotellas,
            opcionotrotaponadobotellas, cantidadotrotaponadobotellas, capacidadotrotaponadobotellas,
            selladomanual, cantidadselladomanual, capacidadselladomanual, selladoautomatico,
            cantidadselladoautomatico, capacidadselladoautomatico, otroselladobotellas,
            opcionotroselladobotellas, cantidadotroselladobotellas, capacidadotroselladobotellas,
            etiquetadomanual, cantidadetiquetadomanual, capacidadetiquetadomanual, etiquetadoautomatico,
            cantidadetiquetadoautomatico, capacidadetiquetadoautomatico, otroetiquetadobotellas,
            opcionotroetiquetadobotellas, cantidadotroetiquetadobotellas, capacidadotroetiquetadobotellas
        }))
        //await dispatch(actualizarFC_36PaginaActivaEnvasado(1))
        props.history.push('/fc_36')
    }
    const botonAgregarAnexoEnvasado = async () => {
        const res = await dispatch(agregarFC_36AnexoUnidadEnvasado({
            id: uuidv4(),
            nocliente, nombrerazonsocial, altainstalaciones, bajainstalaciones,
            fechasolicitud, fechapropuesta, instalacionnumero,
            tipoinstalacion, alias, calle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado,
            codigopostal, referenciascercanas, telefono, correoelectronico,
            nombreresponsable, anforasplastico, cantidadanforasplastico,
            capacidadanforasplastico, tambosplasticos, cantidadtambosplasticos,
            capacidadtambosplasticos, contenedoresplastico1000,
            cantidadcontenedoresplastico100, capacidadcontenedoresplastico10,
            contenedoresplastico5000, cantidadcontenedoresplastico500,
            capacidadcontenedoresplastico50, recipientesaceroinoxidable,
            cantidadrecipientesaceroinoxida, capacidadrecipientesaceroinoxid,
            otroalmacengraneles, opcionotroalmacengraneles,
            cantidadotroalmacengraneles, capacidadotroalmacengraneles, filtrocartucho,
            cantidadfiltrocartucho, caracteristicasfiltrocartucho, filtroprensa, cantidadfiltroprensa,
            caracteristicasfiltroprensa, otrofiltracionmezcal, opcionotrofiltracionmezcal,
            cantidadotrofiltracionmezcal, caracteristicasotrofiltracionme, llenadoramanual,
            cantidadllenadoramanual, capacidadllenadoramanual, llenadoraautomatica,
            cantidadllenadoraautomatica, capacidadllenadoraautomatica, otrollenadobotellas,
            opcionotrollenadobotellas, cantidadotrollenadobotellas, capacidadotrollenadobotellas,
            taponadomanual, cantidadtaponadomanual, capacidadtaponadomanual, taponadoautomatico,
            cantidadtaponadoautomatico, capacidadtaponadoautomatico, otrotaponadobotellas,
            opcionotrotaponadobotellas, cantidadotrotaponadobotellas, capacidadotrotaponadobotellas,
            selladomanual, cantidadselladomanual, capacidadselladomanual, selladoautomatico,
            cantidadselladoautomatico, capacidadselladoautomatico, otroselladobotellas,
            opcionotroselladobotellas, cantidadotroselladobotellas, capacidadotroselladobotellas,
            etiquetadomanual, cantidadetiquetadomanual, capacidadetiquetadomanual, etiquetadoautomatico,
            cantidadetiquetadoautomatico, capacidadetiquetadoautomatico, otroetiquetadobotellas,
            opcionotroetiquetadobotellas, cantidadotroetiquetadobotellas, capacidadotroetiquetadobotellas
        }))
        //await dispatch(actualizarFC_36PaginaActivaEnvasado(1))
        props.history.push('/fc_36')
    }

    const botonRegresarFC_36 = async () => {
        //await dispatch(actualizarFC_36PaginaActivaEnvasado(1))
        props.history.push('/fc_36')
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);

    const botonAceptar = async () => {
        handleOpenModalAceptar()
    }
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="red" align='center'>
                            ¡Advertencia!
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Está a punto de aceptar el anexo unidad de envasado, ya no podrá seguir revisando esta solicitud
                            y los datos se guardarán tal cual fue establecido.<br /> <strong>¿Desea continuar?</strong>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={botonAceptarSolicitud}>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>

        )
    }
    const modoRevision = useSelector(store => store.FC_36SolicitudAtencionACliente.modoRevision)

    const botonAceptarSolicitud = async () => {
        if (modoRevision) {
            if (!(JSON.stringify([]) === JSON.stringify(anexoUnidadEnvasadoMapRevision)) && anexoUnidadEnvasadoMapRevision !== undefined) {
                for (const anexo of anexoUnidadEnvasadoMapRevision) {
                    const id = anexo.data.idfc36_anexounidaddeenvasado
                    if (id === anexoUnidadEnvasadoMap.idfc36_anexounidaddeenvasado) {
                        await dispatch(eliminarFC_36AnexoEnvasadoMapRevision(id))
                    } else {
                        // console.log("no entro")
                    }
                }
            }
            const res = await dispatch(agregarFC_36AnexoUnidadEnvasadoMapRevision({
                idfc36_anexounidaddeenvasado: anexoUnidadEnvasadoMap.idfc36_anexounidaddeenvasado,
                idfc36_anexounidaddeenvasadomap: anexoUnidadEnvasadoMap.idfc36_anexounidaddeenvasadomap,
                nombrerazonsocialcheck, altainstalacionescheck, bajainstalacionescheck, fechasolicitudcheck, fechapropuestacheck, instalacionnumerocheck,
                tipoinstalacioncheck, aliascheck, callecheck, numeroexteriorcheck, numerointeriorcheck, coloniacheck,
                localidadcheck, municipiocheck, estadocheck, codigopostalcheck, referenciascercanascheck, telefonocheck,
                correoelectronicocheck, nombreresponsablecheck, anforasplasticocheck, cantidadanforasplasticocheck,
                capacidadanforasplasticocheck, tambosplasticoscheck, cantidadtambosplasticoscheck, capacidadtambosplasticoscheck,
                contenedoresplastico1000check, cantidadcontplastico100check, capacidadcontplastico10check,
                contenedoresplastico10000check, cantidadcontplastico1000check, capacidadcontplastico100check,
                recipientesaceroinoxidablecheck, cantidadrecaceroinoxidacheck, capacidadrecaceroinoxidcheck,
                otroalmacengranelescheck, opcionotroalmacengranelescheck, cantidadotroalmacengranelescheck,
                capacidadotroalmacengranelescheck, filtrocartuchocheck, cantidadfiltrocartuchocheck,
                caracteristicasfiltrocartuchocheck, filtroprensacheck, cantidadfiltroprensacheck,
                caracteristicasfiltroprensacheck, otrofiltracionmezcalcheck, opcionotrofiltracionmezcalcheck,
                cantidadotrofiltracionmezcalcheck, caracteristicasotrofiltracionmecheck, llenadoramanualcheck,
                cantidadllenadoramanualcheck, capacidadllenadoramanualcheck, llenadoraautomaticacheck,
                cantidadllenadoraautomaticacheck, capacidadllenadoraautomaticacheck, otrollenadobotellascheck,
                opcionotrollenadobotellascheck, cantidadotrollenadobotellascheck, capacidadotrollenadobotellascheck,
                taponadomanualcheck, cantidadtaponadomanualcheck, capacidadtaponadomanualcheck, taponadoautomaticocheck,
                cantidadtaponadoautomaticocheck, capacidadtaponadoautomaticocheck, otrotaponadobotellascheck,
                opcionotrotaponadobotellascheck, cantidadotrotaponadobotellascheck, capacidadotrotaponadobotellascheck,
                selladomanualcheck, cantidadselladomanualcheck, capacidadselladomanualcheck, selladoautomaticocheck,
                cantidadselladoautomaticocheck, capacidadselladoautomaticocheck, otroselladobotellascheck,
                opcionotroselladobotellascheck, cantidadotroselladobotellascheck, capacidadotroselladobotellascheck,
                etiquetadomanualcheck, cantidadetiquetadomanualcheck, capacidadetiquetadomanualcheck, etiquetadoautomaticocheck,
                cantidadetiquetadoautomaticocheck, capacidadetiquetadoautomaticocheck, otroetiquetadobotellascheck,
                opcionotroetiquetadobotellascheck, cantidadotroetiquetadobotellascheck, capacidadotroetiquetadobotellascheck,
                nombrerazonsocial: observaciones.nombrerazonsocial, altainstalaciones: observaciones.altainstalaciones,
                bajainstalaciones: observaciones.bajainstalaciones, fechasolicitud: observaciones.fechasolicitud,
                fechapropuesta: observaciones.fechapropuesta, instalacionnumero: observaciones.instalacionnumero,
                tipoinstalacion: observaciones.tipoinstalacion, alias: observaciones.alias, calle: observaciones.calle,
                numeroexterior: observaciones.numeroexterior, numerointerior: observaciones.numerointerior, colonia: observaciones.colonia,
                localidad: observaciones.localidad, municipio: observaciones.municipio, estado: observaciones.estado,
                codigopostal: observaciones.codigopostal, referenciascercanas: observaciones.referenciascercanas,
                telefono: observaciones.telefono, correoelectronico: observaciones.correoelectronico,
                nombreresponsable: observaciones.nombreresponsable, anforasplastico: observaciones.anforasplastico,
                cantidadanforasplastico: observaciones.cantidadanforasplastico, capacidadanforasplastico: observaciones.capacidadanforasplastico,
                tambosplasticos: observaciones.tambosplasticos, cantidadtambosplasticos: observaciones.cantidadtambosplasticos,
                capacidadtambosplasticos: observaciones.capacidadtambosplasticos, contenedoresplastico1000: observaciones.contenedoresplastico1000,
                cantidadcontplastico100: observaciones.cantidadcontplastico100, capacidadcontplastico10: observaciones.capacidadcontplastico10,
                contenedoresplastico10000: observaciones.contenedoresplastico10000,
                cantidadcontplastico1000: observaciones.cantidadcontplastico1000, capacidadcontplastico100: observaciones.capacidadcontplastico100,
                recipientesaceroinoxidable: observaciones.recipientesaceroinoxidable, cantidadrecaceroinoxida: observaciones.cantidadrecaceroinoxida,
                capacidadrecaceroinoxid: observaciones.capacidadrecaceroinoxid, otroalmacengraneles: observaciones.otroalmacengraneles,
                opcionotroalmacengraneles: observaciones.opcionotroalmacengraneles,
                cantidadotroalmacengraneles: observaciones.cantidadotroalmacengraneles,
                capacidadotroalmacengraneles: observaciones.capacidadotroalmacengraneles, filtrocartucho: observaciones.filtrocartucho,
                cantidadfiltrocartucho: observaciones.cantidadfiltrocartucho,
                caracteristicasfiltrocartucho: observaciones.caracteristicasfiltrocartucho, filtroprensa: observaciones.filtroprensa,
                cantidadfiltroprensa: observaciones.cantidadfiltroprensa, caracteristicasfiltroprensa: observaciones.caracteristicasfiltroprensa,
                otrofiltracionmezcal: observaciones.otrofiltracionmezcal, opcionotrofiltracionmezcal: observaciones.opcionotrofiltracionmezcal,
                cantidadotrofiltracionmezcal: observaciones.cantidadotrofiltracionmezcal,
                caracteristicasotrofiltracionme: observaciones.caracteristicasotrofiltracionme, llenadoramanual: observaciones.llenadoramanual,
                cantidadllenadoramanual: observaciones.cantidadllenadoramanual, capacidadllenadoramanual: observaciones.capacidadllenadoramanual,
                llenadoraautomatica: observaciones.llenadoraautomatica, cantidadllenadoraautomatica: observaciones.cantidadllenadoraautomatica,
                capacidadllenadoraautomatica: observaciones.capacidadllenadoraautomatica, otrollenadobotellas: observaciones.otrollenadobotellas,
                opcionotrollenadobotellas: observaciones.opcionotrollenadobotellas,
                cantidadotrollenadobotellas: observaciones.cantidadotrollenadobotellas,
                capacidadotrollenadobotellas: observaciones.capacidadotrollenadobotellas, taponadomanual: observaciones.taponadomanual,
                cantidadtaponadomanual: observaciones.cantidadtaponadomanual, capacidadtaponadomanual: observaciones.capacidadtaponadomanual,
                taponadoautomatico: observaciones.taponadoautomatico, cantidadtaponadoautomatico: observaciones.cantidadtaponadoautomatico,
                capacidadtaponadoautomatico: observaciones.capacidadtaponadoautomatico, otrotaponadobotellas: observaciones.otrotaponadobotellas,
                opcionotrotaponadobotellas: observaciones.opcionotrotaponadobotellas,
                cantidadotrotaponadobotellas: observaciones.cantidadotrotaponadobotellas,
                capacidadotrotaponadobotellas: observaciones.capacidadotrotaponadobotellas, selladomanual: observaciones.selladomanual,
                cantidadselladomanual: observaciones.cantidadselladomanual, capacidadselladomanual: observaciones.capacidadselladomanual,
                selladoautomatico: observaciones.selladoautomatico, cantidadselladoautomatico: observaciones.cantidadselladoautomatico,
                capacidadselladoautomatico: observaciones.capacidadselladoautomatico, otroselladobotellas: observaciones.otroselladobotellas,
                opcionotroselladobotellas: observaciones.opcionotroselladobotellas,
                cantidadotroselladobotellas: observaciones.cantidadotroselladobotellas,
                capacidadotroselladobotellas: observaciones.capacidadotroselladobotellas,
                etiquetadomanual: observaciones.etiquetadomanual, cantidadetiquetadomanual: observaciones.cantidadetiquetadomanual,
                capacidadetiquetadomanual: observaciones.capacidadetiquetadomanual, etiquetadoautomatico: observaciones.etiquetadoautomatico,
                cantidadetiquetadoautomatico: observaciones.cantidadetiquetadoautomatico,
                capacidadetiquetadoautomatico: observaciones.capacidadetiquetadoautomatico,
                otroetiquetadobotellas: observaciones.otroetiquetadobotellas, opcionotroetiquetadobotellas: observaciones.opcionotroetiquetadobotellas,
                cantidadotroetiquetadobotellas: observaciones.cantidadotroetiquetadobotellas,
                capacidadotroetiquetadobotellas: observaciones.capacidadotroetiquetadobotellas

            }))
            props.history.push('/fc_36')

        } else {
            const id = anexoEnvasadoFormato[0].idfc36_anexounidaddeenvasado
            for (const anexo of anexoUnidadEnvasadoMap) {
                if (id === anexo.data.id) {
                    await dispatch(eliminarFC_36AnexoEnvasadoMap(id))
                } else {
                    // console.log("no encontrado")
                }

            }
            const res = await dispatch(agregarFC_36AnexoUnidadEnvasadoMap({
                id: anexoEnvasadoFormato[0].idfc36_anexounidaddeenvasado,
                nombrerazonsocialcheck, altainstalacionescheck, bajainstalacionescheck, fechasolicitudcheck, fechapropuestacheck, instalacionnumerocheck,
                tipoinstalacioncheck, aliascheck, callecheck, numeroexteriorcheck, numerointeriorcheck, coloniacheck,
                localidadcheck, municipiocheck, estadocheck, codigopostalcheck, referenciascercanascheck, telefonocheck,
                correoelectronicocheck, nombreresponsablecheck, anforasplasticocheck, cantidadanforasplasticocheck,
                capacidadanforasplasticocheck, tambosplasticoscheck, cantidadtambosplasticoscheck, capacidadtambosplasticoscheck,
                contenedoresplastico1000check, cantidadcontplastico100check, capacidadcontplastico10check,
                contenedoresplastico10000check, cantidadcontplastico1000check, capacidadcontplastico100check,
                recipientesaceroinoxidablecheck, cantidadrecaceroinoxidacheck, capacidadrecaceroinoxidcheck,
                otroalmacengranelescheck, opcionotroalmacengranelescheck, cantidadotroalmacengranelescheck,
                capacidadotroalmacengranelescheck, filtrocartuchocheck, cantidadfiltrocartuchocheck,
                caracteristicasfiltrocartuchocheck, filtroprensacheck, cantidadfiltroprensacheck,
                caracteristicasfiltroprensacheck, otrofiltracionmezcalcheck, opcionotrofiltracionmezcalcheck,
                cantidadotrofiltracionmezcalcheck, caracteristicasotrofiltracionmecheck, llenadoramanualcheck,
                cantidadllenadoramanualcheck, capacidadllenadoramanualcheck, llenadoraautomaticacheck,
                cantidadllenadoraautomaticacheck, capacidadllenadoraautomaticacheck, otrollenadobotellascheck,
                opcionotrollenadobotellascheck, cantidadotrollenadobotellascheck, capacidadotrollenadobotellascheck,
                taponadomanualcheck, cantidadtaponadomanualcheck, capacidadtaponadomanualcheck, taponadoautomaticocheck,
                cantidadtaponadoautomaticocheck, capacidadtaponadoautomaticocheck, otrotaponadobotellascheck,
                opcionotrotaponadobotellascheck, cantidadotrotaponadobotellascheck, capacidadotrotaponadobotellascheck,
                selladomanualcheck, cantidadselladomanualcheck, capacidadselladomanualcheck, selladoautomaticocheck,
                cantidadselladoautomaticocheck, capacidadselladoautomaticocheck, otroselladobotellascheck,
                opcionotroselladobotellascheck, cantidadotroselladobotellascheck, capacidadotroselladobotellascheck,
                etiquetadomanualcheck, cantidadetiquetadomanualcheck, capacidadetiquetadomanualcheck, etiquetadoautomaticocheck,
                cantidadetiquetadoautomaticocheck, capacidadetiquetadoautomaticocheck, otroetiquetadobotellascheck,
                opcionotroetiquetadobotellascheck, cantidadotroetiquetadobotellascheck, capacidadotroetiquetadobotellascheck,
                nombrerazonsocial: observaciones.nombrerazonsocial, altainstalaciones: observaciones.altainstalaciones,
                bajainstalaciones: observaciones.bajainstalaciones, fechasolicitud: observaciones.fechasolicitud,
                fechapropuesta: observaciones.fechapropuesta, instalacionnumero: observaciones.instalacionnumero,
                tipoinstalacion: observaciones.tipoinstalacion, alias: observaciones.alias, calle: observaciones.calle,
                numeroexterior: observaciones.numeroexterior, numerointerior: observaciones.numerointerior, colonia: observaciones.colonia,
                localidad: observaciones.localidad, municipio: observaciones.municipio, estado: observaciones.estado,
                codigopostal: observaciones.codigopostal, referenciascercanas: observaciones.referenciascercanas,
                telefono: observaciones.telefono, correoelectronico: observaciones.correoelectronico,
                nombreresponsable: observaciones.nombreresponsable, anforasplastico: observaciones.anforasplastico,
                cantidadanforasplastico: observaciones.cantidadanforasplastico, capacidadanforasplastico: observaciones.capacidadanforasplastico,
                tambosplasticos: observaciones.tambosplasticos, cantidadtambosplasticos: observaciones.cantidadtambosplasticos,
                capacidadtambosplasticos: observaciones.capacidadtambosplasticos, contenedoresplastico1000: observaciones.contenedoresplastico1000,
                cantidadcontplastico100: observaciones.cantidadcontplastico100, capacidadcontplastico10: observaciones.capacidadcontplastico10,
                contenedoresplastico10000: observaciones.contenedoresplastico10000,
                cantidadcontplastico1000: observaciones.cantidadcontplastico1000, capacidadcontplastico100: observaciones.capacidadcontplastico100,
                recipientesaceroinoxidable: observaciones.recipientesaceroinoxidable, cantidadrecaceroinoxida: observaciones.cantidadrecaceroinoxida,
                capacidadrecaceroinoxid: observaciones.capacidadrecaceroinoxid, otroalmacengraneles: observaciones.otroalmacengraneles,
                opcionotroalmacengraneles: observaciones.opcionotroalmacengraneles,
                cantidadotroalmacengraneles: observaciones.cantidadotroalmacengraneles,
                capacidadotroalmacengraneles: observaciones.capacidadotroalmacengraneles, filtrocartucho: observaciones.filtrocartucho,
                cantidadfiltrocartucho: observaciones.cantidadfiltrocartucho,
                caracteristicasfiltrocartucho: observaciones.caracteristicasfiltrocartucho, filtroprensa: observaciones.filtroprensa,
                cantidadfiltroprensa: observaciones.cantidadfiltroprensa, caracteristicasfiltroprensa: observaciones.caracteristicasfiltroprensa,
                otrofiltracionmezcal: observaciones.otrofiltracionmezcal, opcionotrofiltracionmezcal: observaciones.opcionotrofiltracionmezcal,
                cantidadotrofiltracionmezcal: observaciones.cantidadotrofiltracionmezcal,
                caracteristicasotrofiltracionme: observaciones.caracteristicasotrofiltracionme, llenadoramanual: observaciones.llenadoramanual,
                cantidadllenadoramanual: observaciones.cantidadllenadoramanual, capacidadllenadoramanual: observaciones.capacidadllenadoramanual,
                llenadoraautomatica: observaciones.llenadoraautomatica, cantidadllenadoraautomatica: observaciones.cantidadllenadoraautomatica,
                capacidadllenadoraautomatica: observaciones.capacidadllenadoraautomatica, otrollenadobotellas: observaciones.otrollenadobotellas,
                opcionotrollenadobotellas: observaciones.opcionotrollenadobotellas,
                cantidadotrollenadobotellas: observaciones.cantidadotrollenadobotellas,
                capacidadotrollenadobotellas: observaciones.capacidadotrollenadobotellas, taponadomanual: observaciones.taponadomanual,
                cantidadtaponadomanual: observaciones.cantidadtaponadomanual, capacidadtaponadomanual: observaciones.capacidadtaponadomanual,
                taponadoautomatico: observaciones.taponadoautomatico, cantidadtaponadoautomatico: observaciones.cantidadtaponadoautomatico,
                capacidadtaponadoautomatico: observaciones.capacidadtaponadoautomatico, otrotaponadobotellas: observaciones.otrotaponadobotellas,
                opcionotrotaponadobotellas: observaciones.opcionotrotaponadobotellas,
                cantidadotrotaponadobotellas: observaciones.cantidadotrotaponadobotellas,
                capacidadotrotaponadobotellas: observaciones.capacidadotrotaponadobotellas, selladomanual: observaciones.selladomanual,
                cantidadselladomanual: observaciones.cantidadselladomanual, capacidadselladomanual: observaciones.capacidadselladomanual,
                selladoautomatico: observaciones.selladoautomatico, cantidadselladoautomatico: observaciones.cantidadselladoautomatico,
                capacidadselladoautomatico: observaciones.capacidadselladoautomatico, otroselladobotellas: observaciones.otroselladobotellas,
                opcionotroselladobotellas: observaciones.opcionotroselladobotellas,
                cantidadotroselladobotellas: observaciones.cantidadotroselladobotellas,
                capacidadotroselladobotellas: observaciones.capacidadotroselladobotellas,
                etiquetadomanual: observaciones.etiquetadomanual, cantidadetiquetadomanual: observaciones.cantidadetiquetadomanual,
                capacidadetiquetadomanual: observaciones.capacidadetiquetadomanual, etiquetadoautomatico: observaciones.etiquetadoautomatico,
                cantidadetiquetadoautomatico: observaciones.cantidadetiquetadoautomatico,
                capacidadetiquetadoautomatico: observaciones.capacidadetiquetadoautomatico,
                otroetiquetadobotellas: observaciones.otroetiquetadobotellas, opcionotroetiquetadobotellas: observaciones.opcionotroetiquetadobotellas,
                cantidadotroetiquetadobotellas: observaciones.cantidadotroetiquetadobotellas,
                capacidadotroetiquetadobotellas: observaciones.capacidadotroetiquetadobotellas

            }))
            props.history.push('/fc_36')
        }


    }
    return (
        <Fragment>
            <div className='row' id='1'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mt-3 text-center'>
                    {
                        anexoEnvasadoEditable.length === 0 ?
                            (
                                <h2 className='text-center'>ANEXO Unidad de Envasado</h2>) :
                            (

                                <div className='text-center'>
                                    <h4 className='text-center' ><strong>Editando</strong> anexo Unidad de Envasado</h4>
                                </div>
                            )
                    }
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 text-center' >
                    <button onClick={botonRegresarFC_36} className='btn btnNaranja zoom-in-zoom-out'>Regresar a solicitud principal
                    </button>
                </div>
            </div>

            <div className='container2'>
                {
                    paginaActiva === 1 ?
                        (
                            <Fragment>
                                <div className='row align-items-center'>
                                    <h4 className="">De clic en el recuadro del <FontAwesomeIcon icon={faEye} /> para hacer observaciones.</h4>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'>INFORMACIÓN DEL SOLICITANTE</h6>
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" min='1' className={`form-control ${anexoUnidadEnvasadoMap.nombrerazonsocialcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.nombrerazonsocialcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Nombre o razon social' value={nombrerazonsocial} onChange={e => setnombrerazonsocialenvasado(e.target.value)} />
                                            <label className="floatingInput">Nombre o razón social:</label></div>
                                        <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.nombrerazonsocial}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={nombrerazonsocialcheck} onChange={e => checknombrerazonsocialcheck()} checked={nombrerazonsocialcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                </div>
                                <div className='row justify-content-start'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'>SERVICIO SOLICITADO:</h6>
                                    </div>
                                    <div className='col-md-6'>
                                        <br />
                                        <input className={`form-check-input me-1 ${anexoUnidadEnvasadoMap.altainstalacionescheck !== undefined ? (
                                            anexoUnidadEnvasadoMap?.altainstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" id="alta" checked={altainstalaciones} value={altainstalaciones} onChange={e => setAccionInstalacion(e.target)} />
                                        <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.altainstalaciones}</span><br></br>
                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                            Alta de instalaciones:
                                        </label>
                                        <br />
                                        <input className="form-check-input" type="checkbox"
                                            value={altainstalacionescheck} onChange={e => checkaltainstalacionescheck()} checked={altainstalacionescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>
                                        <br />
                                        <input className={`form-check-input me-1 ${anexoUnidadEnvasadoMap.bajainstalacionescheck !== undefined ? (
                                            anexoUnidadEnvasadoMap?.bajainstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" id="baja" checked={bajainstalaciones} value={bajainstalaciones} onChange={e => setAccionInstalacion(e.target)} />
                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                            Baja de instalaciones:
                                        </label>
                                        <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.bajainstalaciones}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={bajainstalacionescheck} onChange={e => checkbajainstalacionescheck()} checked={bajainstalacionescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div><br></br>
                                    <hr></hr><br></br>
                                    <div className='col-md-6'>
                                        <div className="form-floating mb-3">

                                            <div className="form-floating mb-3">
                                                <input type="date" className={`form-control ${anexoUnidadEnvasadoMap.fechasolicitudcheck !== undefined ? (
                                                    anexoUnidadEnvasadoMap?.fechasolicitudcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Fecha de solicitud' value={fechasolicitud} onChange={e => setfechasolicitudenvasado(e.target.value)} />
                                                <label className="floatingInput">Fecha de solicitud:</label></div>
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.fechasolicitud}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={fechasolicitudcheck} onChange={e => checkfechasolicitudcheck()} checked={fechasolicitudcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-floating mb-3">
                                            <input type="date" className={`form-control ${anexoUnidadEnvasadoMap.fechapropuestacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.fechapropuestacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Fecha propuesta' value={fechapropuesta} onChange={e => setfechapropuestaenvasado(e.target.value)} />
                                            <label className="floatingInput">Fecha de visita propuesta</label><br />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.fechapropuesta}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={fechapropuestacheck} onChange={e => checkfechapropuestacheck()} checked={fechapropuestacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                </div>
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'>INFORMACIÓN DE LAS INSTALACIONES</h6>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-floating mb-3">

                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.instalacionnumerocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.instalacionnumerocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Número de instalación' value={instalacionnumero} onChange={e => setinstalacionnumeroenvasado(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Instalación número</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.instalacionnumero}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={instalacionnumerocheck} onChange={e => checkinstalacionnumerocheck()} checked={instalacionnumerocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.tipoinstalacioncheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.tipoinstalacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Calle' value={tipoinstalacion} onChange={e => settipoinstalacionenvasado(e.target.value)} disabled />
                                            <label className="floatingInput">Tipo de instalación: </label>
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.tipoinstalacion}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={tipoinstalacioncheck} onChange={e => checktipoinstalacioncheck()} checked={tipoinstalacioncheck} />

                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>

                                    <div className='col-md-12'>
                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.aliascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.aliascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Nombre de la instalacion' value={alias} onChange={e => setaliasenvasado(e.target.value)} />
                                            <label className="floatingInput"></label>
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.alias}</span>
                                            <input className="form-check-input" type="checkbox"
                                                value={aliascheck} onChange={e => checkaliascheck()} checked={aliascheck} />

                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                            <label className="aling-center"><small>Asignar un "Alias" para identificar cada instalación, esto permitirá diferenciarlas.</small></label>
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-content-start'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'><b>DOMICILIO DE LA INSTALACIÓN:</b></h6>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-floating mb-3">

                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.callecheck !== undefined ? (
                                                    anexoUnidadEnvasadoMap?.callecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Calle' value={calle} onChange={e => setcalleenvasado(e.target.value)} />
                                                <label className="floatingInput">Calle</label>
                                            </div>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.calle}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={callecheck} onChange={e => checkcallecheck()} checked={callecheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <div className='col-md-3'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadEnvasadoMap.numeroexteriorcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.numeroexteriorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='N° exterior' value={numeroexterior} onChange={e => setnumeroexteriorenvasado(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Número exterior</label>
                                            <span className='text-danger'>{anexoUnidadEnvasadoMap?.numeroexterior}</span>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={numeroexteriorcheck} onChange={e => checknumeroexteriorcheck()} checked={numeroexteriorcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadEnvasadoMap.numerointeriorcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.numerointeriorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='N° interior' value={numerointerior} onChange={e => setnumerointeriorenvasado(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Numero interior</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.numerointerior}</span><br></br>

                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={numerointeriorcheck} onChange={e => checknumerointeriorcheck()} checked={numerointeriorcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.coloniacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.coloniacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Colonia' value={colonia} onChange={e => setcoloniaenvasado(e.target.value)} />
                                            <label className="floatingInput">Colonia</label>
                                            <span className='text-danger'>{anexoUnidadEnvasadoMap?.colonia}</span>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={coloniacheck} onChange={e => checkcoloniacheck()} checked={coloniacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.localidadcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.localidadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Localidad' value={localidad} onChange={e => setlocalidadenvasado(e.target.value)} />
                                            <label className="floatingInput">Localidad</label>
                                        </div>
                                        <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.localidad}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={localidadcheck} onChange={e => checklocalidadcheck()} checked={localidadcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.municipiocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.municipiocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Delegacion/Municipio' value={municipio} onChange={e => setmunicipioenvasado(e.target.value)} />
                                            <label className="floatingInput">Delegación/Municipio</label>
                                        </div>
                                        <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.municipio}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={municipiocheck} onChange={e => checkmunicipiocheck()} checked={municipiocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.estadocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.estadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Estado' value={estado} onChange={e => setestadoenvasado(e.target.value)} />
                                            <label className="floatingInput">Estado</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.estado}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={estadocheck} onChange={e => checkestadocheck()} checked={estadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadEnvasadoMap.codigopostalcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.codigopostalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Codigo postal' value={codigopostal} onChange={e => setcodigopostalenvasado(e.target.value)} />
                                            <label className="floatingInput">Código postal</label>
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.codigopostal}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={codigopostalcheck} onChange={e => checkcodigopostalcheck()} checked={codigopostalcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" min='0' className={`form-control ${anexoUnidadEnvasadoMap.referenciascercanascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.referenciascercanascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Indique los lugares cercanos que permitan localizar con facilidad sus instalaciones, o las calles entre las que se encuentra.' value={referenciascercanas} onChange={e => setreferenciascercanasenvasado(e.target.value)} />
                                            <label className="floatingInput">Referencias cercanas:</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.referenciascercanas}</span><br />
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={referenciascercanascheck} onChange={e => checkreferenciascercanascheck()} checked={referenciascercanascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.telefonocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Telefono' value={telefono} onChange={e => settelefonoenvasado(e.target.value)} />
                                            <label className="floatingInput">Teléfono</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.telefono}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={telefonocheck} onChange={e => checktelefonocheck()} checked={telefonocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="email" className={`form-control ${anexoUnidadEnvasadoMap.correoelectronicocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='ejemplo@gmail.com' value={correoelectronico} onChange={e => setcorreoelectronicoenvasado(e.target.value)} />
                                            <label className="floatingInput">Correo electrónico</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.correoelectronico}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={correoelectronicocheck} onChange={e => checkcorreoelectronicocheck()} checked={correoelectronicocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.nombreresponsablecheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.nombreresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Nombre del responsable' value={nombreresponsable} onChange={e => setnombreresponsableenvasado(e.target.value)} />
                                            <label className="floatingInput">Nombre del responsable</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.nombreresponsable}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={nombreresponsablecheck} onChange={e => checknombreresponsablecheck()} checked={nombreresponsablecheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                </div>
                            </Fragment>
                        )
                        :
                        paginaActiva === 2 ?
                            (
                                <Fragment>
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'>DESCRIPCIÓN DE LA UNIDAD DE ENVASADO</h6>
                                        </div>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Almacén de graneles</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de recipiente</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Capacidad (Litros)</label>
                                            </div>

                                        </div>

                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.anforasplasticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.anforasplasticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={anforasplastico} value={anforasplastico} onChange={e => setanforasplasticoenvasado(e.target.checked)} />
                                            <label className="ms-3">Ánforas de plastico {menor} 100 L</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.anforasplastico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={anforasplasticocheck} onChange={e => checkanforasplasticocheck()} checked={anforasplasticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadanforasplasticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadanforasplasticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadanforasplastico} onChange={e => setcantidadanforasplasticoenvasado(e.target.valueAsNumber)} disabled={!anforasplastico} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadanforasplastico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadanforasplasticocheck} onChange={e => checkcantidadanforasplasticocheck()} checked={cantidadanforasplasticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadanforasplasticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadanforasplasticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadanforasplastico} onChange={e => setcapacidadanforasplasticoenvasado(e.target.valueAsNumber)} disabled={!anforasplastico} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadanforasplastico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadanforasplasticocheck} onChange={e => checkcapacidadanforasplasticocheck()} checked={capacidadanforasplasticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.tambosplasticoscheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.tambosplasticoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={tambosplasticos} value={tambosplasticos} onChange={e => settambosplasticosenvasado(e.target.checked)} />
                                            <label className="ms-3">Tambos de plastico {mayor} 100 L</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.tambosplasticos}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={tambosplasticoscheck} onChange={e => checktambosplasticoscheck()} checked={tambosplasticoscheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadtambosplasticoscheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadtambosplasticoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadtambosplasticos} onChange={e => setcantidadtambosplasticosenvasado(e.target.valueAsNumber)} disabled={!tambosplasticos} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadtambosplasticos}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadtambosplasticoscheck} onChange={e => checkcantidadtambosplasticoscheck()} checked={cantidadtambosplasticoscheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadtambosplasticoscheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadtambosplasticoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadtambosplasticos} onChange={e => setcapacidadtambosplasticosenvasado(e.target.valueAsNumber)} disabled={!tambosplasticos} />
                                            <br></br>  <span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadtambosplasticos}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadtambosplasticoscheck} onChange={e => checkcapacidadtambosplasticoscheck()} checked={capacidadtambosplasticoscheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.contenedoresplastico1000check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.contenedoresplastico1000check ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={contenedoresplastico1000} value={contenedoresplastico1000} onChange={e => setcontenedoresplastico1000envasado(e.target.checked)} />
                                            <label className="ms-3">Contenedores de plastico {mayor} 1000 L</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.contenedoresplastico1000}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={contenedoresplastico1000check} onChange={e => checkcontenedoresplastico1000check()} checked={contenedoresplastico1000check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadcontenedoresplastico100check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadcontenedoresplastico100check ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadcontenedoresplastico100} onChange={e => setcantidadcontenedoresplastico100envasado(e.target.valueAsNumber)} disabled={!contenedoresplastico1000} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadcontenedoresplastico100}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadcontplastico100check} onChange={e => checkcantidadcontplastico100check()} checked={cantidadcontplastico100check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadcontenedoresplastico10check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadcontenedoresplastico10check ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadcontenedoresplastico10} onChange={e => setcapacidadcontenedoresplastico10envasado(e.target.valueAsNumber)} disabled={!contenedoresplastico1000} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadcontenedoresplastico10}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadcontplastico10check} onChange={e => checkcapacidadcontplastico10check()} checked={capacidadcontplastico10check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.contenedoresplastico5000check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.contenedoresplastico5000check ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={contenedoresplastico5000} value={contenedoresplastico5000} onChange={e => setcontenedoresplastico5000envasado(e.target.checked)} />
                                            <label className="ms-3">Contenedores de plastico {mayor} 5000 L</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.contenedoresplastico5000}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={contenedoresplastico10000check} onChange={e => checkcontenedoresplastico10000check()} checked={contenedoresplastico10000check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadcontenedoresplastico500check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadcontenedoresplastico500check ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadcontenedoresplastico500} onChange={e => setcantidadcontenedoresplastico500envasado(e.target.valueAsNumber)} disabled={!contenedoresplastico5000} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadcontenedoresplastico500}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadcontplastico1000check} onChange={e => checkcantidadcontplastico1000check()} checked={cantidadcontplastico1000check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadcontenedoresplastico50check !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadcontenedoresplastico50check ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadcontenedoresplastico50} onChange={e => setcapacidadcontenedoresplastico50envasado(e.target.valueAsNumber)} disabled={!contenedoresplastico5000} />
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadcontenedoresplastico50}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadcontplastico100check} onChange={e => checkcapacidadcontplastico100check()} checked={capacidadcontplastico100check} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.recipientesaceroinoxidablecheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.recipientesaceroinoxidablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={recipientesaceroinoxidable} value={recipientesaceroinoxidable} onChange={e => setrecipientesaceroinoxidableenvasado(e.target.checked)} />
                                            <label className="ms-3">Recipientes de acero inoxidable</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.recipientesaceroinoxidable}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={recipientesaceroinoxidablecheck} onChange={e => checkrecipientesaceroinoxidablecheck()} checked={recipientesaceroinoxidablecheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadrecipientesaceroinoxidacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadrecipientesaceroinoxidacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadrecipientesaceroinoxida} onChange={e => setcantidadrecipientesaceroinoxidaenvasado(e.target.valueAsNumber)} disabled={!recipientesaceroinoxidable} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadrecipientesaceroinoxida}</span><br />
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadrecaceroinoxidacheck} onChange={e => checkcantidadrecaceroinoxidacheck()} checked={cantidadrecaceroinoxidacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadrecipientesaceroinoxidcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadrecipientesaceroinoxidcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadrecipientesaceroinoxid} onChange={e => setcapacidadrecipientesaceroinoxidenvasado(e.target.valueAsNumber)} disabled={!recipientesaceroinoxidable} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadrecipientesaceroinoxid}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadrecaceroinoxidcheck} onChange={e => checkcapacidadrecaceroinoxidcheck()} checked={capacidadrecaceroinoxidcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                        <div className='col-md-3'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otroalmacengranelescheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otroalmacengranelescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={otroalmacengraneles} value={otroalmacengraneles} onChange={e => setotroalmacengranelesenvasado(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.otroalmacengraneles}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={otroalmacengranelescheck} onChange={e => checkotroalmacengranelescheck()} checked={otroalmacengranelescheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotroalmacengranelescheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotroalmacengranelescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotroalmacengraneles} onChange={e => setopcionotroalmacengranelesenvasado(e.target.value)} disabled={!otroalmacengraneles} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotroalmacengraneles}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotroalmacengranelescheck} onChange={e => checkopcionotroalmacengranelescheck()} checked={opcionotroalmacengranelescheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotroalmacengranelescheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotroalmacengranelescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotroalmacengraneles} onChange={e => setcantidadotroalmacengranelesenvasado(e.target.valueAsNumber)} disabled={!otroalmacengraneles} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotroalmacengraneles}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotroalmacengranelescheck} onChange={e => checkcantidadotroalmacengranelescheck()} checked={cantidadotroalmacengranelescheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadotroalmacengranelescheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadotroalmacengranelescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadotroalmacengraneles} onChange={e => setcapacidadotroalmacengranelesenvasado(e.target.valueAsNumber)} disabled={!otroalmacengraneles} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadotroalmacengraneles}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadotroalmacengranelescheck} onChange={e => checkcapacidadotroalmacengranelescheck()} checked={capacidadotroalmacengranelescheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <br />
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Equipo utilizado para filtracion de mezcal</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de filtro</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Caracteristicas</label>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.filtrocartuchocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.filtrocartuchocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={filtrocartucho} value={filtrocartucho} onChange={e => setfiltrocartucho(e.target.checked)} />
                                            <label className="ms-3">Filtro de cartucho</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.filtrocartucho}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={filtrocartuchocheck} onChange={e => checkfiltrocartuchocheck()} checked={filtrocartuchocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadfiltrocartuchocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadfiltrocartuchocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadfiltrocartucho} onChange={e => setcantidadfiltrocartucho(e.target.valueAsNumber)} disabled={!filtrocartucho} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadfiltrocartucho}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadfiltrocartuchocheck} onChange={e => checkcantidadfiltrocartuchocheck()} checked={cantidadfiltrocartuchocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.caracteristicasfiltrocartuchocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.caracteristicasfiltrocartuchocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Caracterisiticas' value={caracteristicasfiltrocartucho} onChange={e => setcaracteristicasfiltrocartucho(e.target.value)} disabled={!filtrocartucho} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.caracteristicasfiltrocartucho}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={caracteristicasfiltrocartuchocheck} onChange={e => checkcaracteristicasfiltrocartuchocheck()} checked={caracteristicasfiltrocartuchocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.filtroprensacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.filtroprensacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='filtroPrensa' checked={filtroprensa} value={filtroprensa} onChange={e => setfiltroprensa(e.target.checked)} />
                                            <label className="ms-3">Filtro de prensa</label>
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.filtroprensa}</span><br></br>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadfiltroprensa}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={filtroprensacheck} onChange={e => checkfiltroprensacheck()} checked={filtroprensacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadfiltroprensacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadfiltroprensacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadfiltroprensa} onChange={e => setcantidadfiltroprensa(e.target.valueAsNumber)} disabled={!filtroprensa} />
                                            <br></br>  <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadfiltroprensa}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadfiltroprensacheck} onChange={e => checkcantidadfiltroprensacheck()} checked={cantidadfiltroprensacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.caracteristicasfiltroprensacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.caracteristicasfiltroprensacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Caracterisiticas' value={caracteristicasfiltroprensa} onChange={e => setcaracteristicasfiltroprensa(e.target.value)} disabled={!filtroprensa} />
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.caracteristicasfiltroprensa}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={caracteristicasfiltroprensacheck} onChange={e => checkcaracteristicasfiltroprensacheck()} checked={caracteristicasfiltroprensacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3' >
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otrofiltracionmezcalcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otrofiltracionmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='Otro' checked={otrofiltracionmezcal} value={otrofiltracionmezcal} onChange={e => setotrofiltracionmezcal(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.otrofiltracionmezcal}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={otrofiltracionmezcalcheck} onChange={e => checkotrofiltracionmezcalcheck()} checked={otrofiltracionmezcalcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotrofiltracionmezcalcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotrofiltracionmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotrofiltracionmezcal} onChange={e => setopcionotrofiltracionmezcal(e.target.value)} disabled={!otrofiltracionmezcal} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotrofiltracionmezcal}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotrofiltracionmezcalcheck} onChange={e => checkopcionotrofiltracionmezcalcheck()} checked={opcionotrofiltracionmezcalcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotrofiltracionmezcalcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotrofiltracionmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotrofiltracionmezcal} onChange={e => setcantidadotrofiltracionmezcal(e.target.valueAsNumber)} disabled={!otrofiltracionmezcal} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotrofiltracionmezcal}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotrofiltracionmezcalcheck} onChange={e => checkcantidadotrofiltracionmezcalcheck()} checked={cantidadotrofiltracionmezcalcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.caracteristicasotrofiltracionmecheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.caracteristicasotrofiltracionmecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='caracteristicas' value={caracteristicasotrofiltracionme} onChange={e => setcaracteristicasotrofiltracionme(e.target.value)} disabled={!otrofiltracionmezcal} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.caracteristicasotrofiltracionme}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={caracteristicasotrofiltracionmecheck} onChange={e => checkcaracteristicasotrofiltracionmecheck()} checked={caracteristicasotrofiltracionmecheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <br />
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Equipo utilizado para llenado de botellas</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de equipo</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Capacidad (Botellas/Horas)</label>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.llenadoramanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.llenadoramanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={llenadoramanual} value={llenadoramanual} onChange={e => setllenadoramanual(e.target.checked)} />
                                            <label className="ms-3">Llenadora manual</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.llenadoramanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={llenadoramanualcheck} onChange={e => checkllenadoramanualcheck()} checked={llenadoramanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadllenadoramanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadllenadoramanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadllenadoramanual} onChange={e => setcantidadllenadoramanual(e.target.valueAsNumber)} disabled={!llenadoramanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadllenadoramanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadllenadoramanualcheck} onChange={e => checkcantidadllenadoramanualcheck()} checked={cantidadllenadoramanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadllenadoramanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadllenadoramanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadllenadoramanual} onChange={e => setcapacidadllenadoramanual(e.target.valueAsNumber)} disabled={!llenadoramanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadllenadoramanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadllenadoramanualcheck} onChange={e => checkcapacidadllenadoramanualcheck()} checked={capacidadllenadoramanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.llenadoraautomaticacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.llenadoraautomaticacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='llenadoraAutomatica' checked={llenadoraautomatica} value={llenadoraautomatica} onChange={e => setllenadoraautomatica(e.target.checked)} />
                                            <label className="ms-3">Llenadora automatica</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.llenadoraautomatica}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={llenadoraautomaticacheck} onChange={e => checkllenadoraautomaticacheck()} checked={llenadoraautomaticacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadllenadoraautomaticacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadllenadoraautomaticacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadllenadoraautomatica} onChange={e => setcantidadllenadoraautomatica(e.target.valueAsNumber)} disabled={!llenadoraautomatica} />
                                            <br></br>  <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadllenadoraautomatica}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadllenadoraautomaticacheck} onChange={e => checkcantidadllenadoraautomaticacheck()} checked={cantidadllenadoraautomaticacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadllenadoraautomaticacheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadllenadoraautomaticacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadllenadoraautomatica} onChange={e => setcapacidadllenadoraautomatica(e.target.valueAsNumber)} disabled={!llenadoraautomatica} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadllenadoraautomatica}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadllenadoraautomaticacheck} onChange={e => checkcapacidadllenadoraautomaticacheck()} checked={capacidadllenadoraautomaticacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3' >
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otrollenadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otrollenadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={otrollenadobotellas} value={otrollenadobotellas} onChange={e => setotrollenadobotellas(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.otrollenadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={otrollenadobotellascheck} onChange={e => checkotrollenadobotellascheck()} checked={otrollenadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotrollenadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotrollenadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotrollenadobotellas} onChange={e => setopcionotrollenadobotellas(e.target.value)} disabled={!otrollenadobotellas} />
                                            <br></br>  <span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotrollenadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotrollenadobotellascheck} onChange={e => checkopcionotrollenadobotellascheck()} checked={opcionotrollenadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotrollenadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotrollenadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotrollenadobotellas} onChange={e => setcantidadotrollenadobotellas(e.target.valueAsNumber)} disabled={!otrollenadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotrollenadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotrollenadobotellascheck} onChange={e => checkcantidadotrollenadobotellascheck()} checked={cantidadotrollenadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadotrollenadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadotrollenadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadotrollenadobotellas} onChange={e => setcapacidadotrollenadobotellas(e.target.valueAsNumber)} disabled={!otrollenadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadotrollenadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadotrollenadobotellascheck} onChange={e => checkcapacidadotrollenadobotellascheck()} checked={capacidadotrollenadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <br />
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Equipo utilizado para taponado de botellas</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de equipo</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Capacidad (Botellas/Horas)</label>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.taponadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.taponadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={taponadomanual} value={taponadomanual} onChange={e => settaponadomanual(e.target.checked)} />
                                            <label className="ms-3">Taponado manual</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.taponadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={taponadomanualcheck} onChange={e => checktaponadomanualcheck()} checked={taponadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadtaponadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadtaponadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadtaponadomanual} onChange={e => setcantidadtaponadomanual(e.target.valueAsNumber)} disabled={!taponadomanual} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadtaponadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadtaponadomanualcheck} onChange={e => checkcantidadtaponadomanualcheck()} checked={cantidadtaponadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadtaponadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadtaponadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadtaponadomanual} onChange={e => setcapacidadtaponadomanual(e.target.valueAsNumber)} disabled={!taponadomanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadtaponadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadtaponadomanualcheck} onChange={e => checkcapacidadtaponadomanualcheck()} checked={capacidadtaponadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.taponadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.taponadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={taponadoautomatico} value={taponadoautomatico} onChange={e => settaponadoautomatico(e.target.checked)} />
                                            <label className="ms-3">Taponado automatica</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.taponadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={taponadoautomaticocheck} onChange={e => checktaponadoautomaticocheck()} checked={taponadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadtaponadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadtaponadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadtaponadoautomatico} onChange={e => setcantidadtaponadoautomatico(e.target.valueAsNumber)} disabled={!taponadoautomatico} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadtaponadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadtaponadoautomaticocheck} onChange={e => checkcantidadtaponadoautomaticocheck()} checked={cantidadtaponadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadtaponadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadtaponadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadtaponadoautomatico} onChange={e => setcapacidadtaponadoautomatico(e.target.valueAsNumber)} disabled={!taponadoautomatico} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadtaponadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadtaponadoautomaticocheck} onChange={e => checkcapacidadtaponadoautomaticocheck()} checked={capacidadtaponadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3' >
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otrotaponadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otrotaponadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' checked={otrotaponadobotellas} value={otrotaponadobotellas} onChange={e => setotrotaponadobotellas(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.otrotaponadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={otrotaponadobotellascheck} onChange={e => checkotrotaponadobotellascheck()} checked={otrotaponadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotrotaponadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotrotaponadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotrotaponadobotellas} onChange={e => setopcionotrotaponadobotellas(e.target.value)} disabled={!otrotaponadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotrotaponadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotrotaponadobotellascheck} onChange={e => checkopcionotrotaponadobotellascheck()} checked={opcionotrotaponadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotrotaponadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotrotaponadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotrotaponadobotellas} onChange={e => setcantidadotrotaponadobotellas(e.target.valueAsNumber)} disabled={!otrotaponadobotellas} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotrotaponadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotrotaponadobotellascheck} onChange={e => checkcantidadotrotaponadobotellascheck()} checked={cantidadotrotaponadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadotrotaponadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadotrotaponadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadotrotaponadobotellas} onChange={e => setcapacidadotrotaponadobotellas(e.target.valueAsNumber)} disabled={!otrotaponadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadotrotaponadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadotrotaponadobotellascheck} onChange={e => checkcapacidadotrotaponadobotellascheck()} checked={capacidadotrotaponadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <br />
                                </Fragment>
                            )
                            :
                            (
                                <Fragment>
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Equipo para sellado de botellas</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de equipo</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Capacidad (Botellas/Horas)</label>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.selladomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.selladomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='sellado manual' checked={selladomanual} value={selladomanual} onChange={e => setselladomanual(e.target.checked)} />
                                            <label className="ms-3">Sellado manual</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.selladomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={selladomanualcheck} onChange={e => checkselladomanualcheck()} checked={selladomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadselladomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadselladomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadselladomanual} onChange={e => setcantidadselladomanual(e.target.valueAsNumber)} disabled={!selladomanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadselladomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadselladomanualcheck} onChange={e => checkcantidadselladomanualcheck()} checked={cantidadselladomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadselladomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadselladomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadselladomanual} onChange={e => setcapacidadselladomanual(e.target.valueAsNumber)} disabled={!selladomanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadselladomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadselladomanualcheck} onChange={e => checkcapacidadselladomanualcheck()} checked={capacidadselladomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.selladoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.selladoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='sellado' checked={selladoautomatico} value={selladoautomatico} onChange={e => setselladoautomatico(e.target.checked)} />
                                            <label className="ms-3">Sellado automatica</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.selladoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={selladoautomaticocheck} onChange={e => checkselladoautomaticocheck()} checked={selladoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadselladoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadselladoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadselladoautomatico} onChange={e => setcantidadselladoautomatico(e.target.valueAsNumber)} disabled={!selladoautomatico} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadselladoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadselladoautomaticocheck} onChange={e => checkcantidadselladoautomaticocheck()} checked={cantidadselladoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadselladoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadselladoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadselladoautomatico} onChange={e => setcapacidadselladoautomatico(e.target.valueAsNumber)} disabled={!selladoautomatico} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadselladoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadselladoautomaticocheck} onChange={e => checkcapacidadselladoautomaticocheck()} checked={capacidadselladoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3' >
                                            <input className="ms-2 form-check-input me-1" type="checkbox" name='otro' checked={otroselladobotellas} value={otroselladobotellas} onChange={e => setotroselladobotellas(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.otroselladobotellas}</span><br></br>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otroselladobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otroselladobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                value={otroselladobotellascheck} onChange={e => checkotroselladobotellascheck()} checked={otroselladobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotroselladobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotroselladobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotroselladobotellas} onChange={e => setopcionotroselladobotellas(e.target.value)} disabled={!otroselladobotellas} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotroselladobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotroselladobotellascheck} onChange={e => checkopcionotroselladobotellascheck()} checked={opcionotroselladobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotroselladobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotroselladobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotroselladobotellas} onChange={e => setcantidadotroselladobotellas(e.target.valueAsNumber)} disabled={!otroselladobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotroselladobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotroselladobotellascheck} onChange={e => checkcantidadotroselladobotellascheck()} checked={cantidadotroselladobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadotroselladobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadotroselladobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadotroselladobotellas} onChange={e => setcapacidadotroselladobotellas(e.target.valueAsNumber)} disabled={!otroselladobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadotroselladobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadotroselladobotellascheck} onChange={e => checkcapacidadotroselladobotellascheck()} checked={capacidadotroselladobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                    <br />
                                    <div className='row align-items-center'>
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'><b>Etiquetado de botella</b></h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className='col-md-6'>
                                                <label className="ms-3">Tipo de equipo</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Cantidad</label>
                                            </div>
                                            <div className='col-md-3'>
                                                <label className="ms-3">Capacidad (Botellas/Horas)</label>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.etiquetadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.etiquetadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='sellado manual' checked={etiquetadomanual} value={etiquetadomanual} onChange={e => setetiquetadomanual(e.target.checked)} />
                                            <label className="ms-3">Etiquetado manual</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.etiquetadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={etiquetadomanualcheck} onChange={e => checketiquetadomanualcheck()} checked={etiquetadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadetiquetadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadetiquetadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadetiquetadomanual} onChange={e => setcantidadetiquetadomanual(e.target.valueAsNumber)} disabled={!etiquetadomanual} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadetiquetadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadetiquetadomanualcheck} onChange={e => checkcantidadetiquetadomanualcheck()} checked={cantidadetiquetadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadetiquetadomanualcheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadetiquetadomanualcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadetiquetadomanual} onChange={e => setcapacidadetiquetadomanual(e.target.valueAsNumber)} disabled={!etiquetadomanual} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadetiquetadomanual}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadetiquetadomanualcheck} onChange={e => checkcapacidadetiquetadomanualcheck()} checked={capacidadetiquetadomanualcheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-6'>
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.etiquetadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.etiquetadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='sellado' checked={etiquetadoautomatico} value={etiquetadoautomatico} onChange={e => setetiquetadoautomatico(e.target.checked)} />
                                            <label className="ms-3">Etiquetado automatico</label>
                                            <br /><span className='text-danger'>{anexoUnidadEnvasadoMap?.etiquetadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={etiquetadoautomaticocheck} onChange={e => checketiquetadoautomaticocheck()} checked={etiquetadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadetiquetadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadetiquetadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadetiquetadoautomatico} onChange={e => setcantidadetiquetadoautomatico(e.target.valueAsNumber)} disabled={!etiquetadoautomatico} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadetiquetadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadetiquetadoautomaticocheck} onChange={e => checkcantidadetiquetadoautomaticocheck()} checked={cantidadetiquetadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadetiquetadoautomaticocheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadetiquetadoautomaticocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadetiquetadoautomatico} onChange={e => setcapacidadetiquetadoautomatico(e.target.valueAsNumber)} disabled={!etiquetadoautomatico} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadetiquetadoautomatico}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadetiquetadoautomaticocheck} onChange={e => checkcapacidadetiquetadoautomaticocheck()} checked={capacidadetiquetadoautomaticocheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3' >
                                            <input className={`ms-2 form-check-input me-1 ${anexoUnidadEnvasadoMap.otroetiquetadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.otroetiquetadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='otro' checked={otroetiquetadobotellas} value={otroetiquetadobotellas} onChange={e => setotroetiquetadobotellas(e.target.checked)} />
                                            <label className="ms-3">Otro</label>
                                            <br /> <span className='text-danger'>{anexoUnidadEnvasadoMap?.otroetiquetadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={otroetiquetadobotellascheck} onChange={e => checkotroetiquetadobotellascheck()} checked={otroetiquetadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="text" className={`form-control ${anexoUnidadEnvasadoMap.opcionotroetiquetadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.opcionotroetiquetadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Otro' value={opcionotroetiquetadobotellas} onChange={e => setopcionotroetiquetadobotellas(e.target.value)} disabled={!otroetiquetadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.opcionotroetiquetadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={opcionotroetiquetadobotellascheck} onChange={e => checkopcionotroetiquetadobotellascheck()} checked={opcionotroetiquetadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.cantidadotroetiquetadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.cantidadotroetiquetadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='cantidad' value={cantidadotroetiquetadobotellas} onChange={e => setcantidadotroetiquetadobotellas(e.target.valueAsNumber)} disabled={!otroetiquetadobotellas} />
                                            <br></br> <span className='text-danger'>{anexoUnidadEnvasadoMap?.cantidadotroetiquetadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={cantidadotroetiquetadobotellascheck} onChange={e => checkcantidadotroetiquetadobotellascheck()} checked={cantidadotroetiquetadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                        <div className='col-md-3'>
                                            <input type="number" className={`form-control ${anexoUnidadEnvasadoMap.capacidadotroetiquetadobotellascheck !== undefined ? (
                                                anexoUnidadEnvasadoMap?.capacidadotroetiquetadobotellascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} placeholder='Capacidad' value={capacidadotroetiquetadobotellas} onChange={e => setcapacidadotroetiquetadobotellas(e.target.valueAsNumber)} disabled={!otroetiquetadobotellas} />
                                            <br></br><span className='text-danger'>{anexoUnidadEnvasadoMap?.capacidadotroetiquetadobotellas}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={capacidadotroetiquetadobotellascheck} onChange={e => checkcapacidadotroetiquetadobotellascheck()} checked={capacidadotroetiquetadobotellascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>

                                    </div>

                                    <div className=" text-align: justify">
                                        <br />
                                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-center ${estilos.labelNaranja}`}>
                                            <h6 className='text-center'>DECLARACIONES Y CONSIDERACIONES</h6>
                                        </div>
                                        <div align="justify">
                                            <label className="floatingInput"><b>EL CLIENTE DECLARA BAJO PROTESTA DE DECIR VERDAD:</b></label>
                                            <br />
                                            <ol type="a">
                                                <li>Que los datos contenidos en la presente solicitud son ciertos y,</li>
                                                <li>Que ha leído y comprendido el contenido completo de los
                                                    documentos: "Manual básico para inscripción y certificación ante COMERCAM (DC-02)", "Descripción
                                                    de la información comercial (DC-07)", "Esquema de evaluación de la conformidad (DC-01)",
                                                    "Uso     adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)",
                                                    "Procedimiento de producto certificado (P-PC)" vigentes, la ley de Infraestructura de la Calidad
                                                    (LIC) artículo 56 fracción I,II y III, artículo 60 fracción I, III, IV y la "NOM-070-SCFI-2016,
                                                    Bebidas Alcohólicas-Mezcal Especificaciones", vigente.</li>
                                            </ol>
                                            <label className="floatingInput"><b>LA EMPRESA ATRAVEZ DE SU REPRESENTANTE LEGAL Y AUTORIZADO SE COMPROMETE A CUMPLIR CON:</b></label>
                                            <br />
                                            <ol align="justify" type="a">

                                                <li>La Norma Oficial Mexicana  NOM-070-SCFI-2016 “Bebidas Alcohólicas-Mezcal Especificaciones”,
                                                    en vigor y los Criterios Autorizados por la Dirección General de Normas (DGN) </li>
                                                <li>Lo establecido en  el "Esquema de evaluación de la conformidad (DC-01)" , "Uso adecuado de la contraseña oficial NOM
                                                    (DC-05)",  " Uso adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)", "Procedimiento
                                                    de producto certificado (P-PC)".</li>
                                                <li>Cubrir las tarifas correspondientes al servicio solicitado y los gastos por  concepto de viáticos de los inspectores
                                                    asignados para el proceso.</li>
                                            </ol>
                                            <p>
                                                <b>CONSIDERACIONES:</b>Este formato es de distribución gratuita. Se autoriza su libre reproducción, siempre y cuando éste no sea
                                                alterado y sea presentado impreso en una hoja de papel blanco, tamaño carta, completamente requisitada, firmada y rubricada
                                                por el representante autorizado o legal de forma autógrafa.
                                            </p>
                                            <br />
                                            <br />

                                            <div className="d-grid gap-2 col-6 mx-auto">
                                                <div className="text-center">
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptar} >Aceptar Observaciones</button>
                                                </div>
                                                {modalComponentAceptar()}
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            )
                }

                {modalComponentObservaciones(campoParaObservacion)}
                <div className='row ms-5 text-center mt-5'>
                    <ToolBarPaginas componente='fc_36Envasado' paginas={paginas} />
                </div>
            </div>

        </Fragment>
    )
}

export default withRouter(FC_36AnexoEnvasadoComponent)
